import { t as e } from "./rolldown-runtime-Dy4uBu1J.js";
import { n as t, t as n } from "./createEndpoints-BYEC3FIA.js";
import { a as r, i, n as a, o as ee, r as te, t as o } from "./sanitiseRequestBody-Dm5hzjxP.js";
import { t as s } from "./createQueryParams-D2aMgLX5.js";
import ne from "tiny-invariant";
//#region src/clients/dashboard/v20240730/endpoints/bulkActions/bulkActions.cacheKeys.ts
var c = "bulkActions", re = t({
	route: (e) => `/bulk-actions${s(e)}`,
	queryKey: [c],
	mocking: {
		match: /\/api\/bulk-actions$/,
		mock: {
			items: [],
			pagination: {
				after: "MDE4NDUyNjYtNmQ2NC03N2M4LTlhZGYtNDQ4N2Q5NGQxNDU3",
				before: "MDE4NDQyMWUtYTljYy03MTFiLWFmOTMtYmYwNTExZDRkODMz",
				totalResultSize: 1
			}
		}
	}
}), ie = n({
	route: (e) => `/bulk-actions/${e.id}/review`,
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/api\/bulk-actions\/(.+)\/review$/,
		mock: {
			id: "018ee64c-d146-79a8-9c07-9798d1462fd8",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			createdAt: "2022-06-28T16:47:00Z",
			type: "VOID_INVOICES",
			status: "COMPLETED_WITH_FAILURES",
			requestedIds: ["018ee663-e185-7b2c-9373-28c97e26f7f9", "018ee663-fbe4-7d2b-8758-3d870b2888df"],
			skippedIds: [],
			completedIds: ["018ee663-fbe4-7d2b-8758-3d870b2888df"],
			failedIds: ["018ee663-e185-7b2c-9373-28c97e26f7f9"],
			reviewedAt: "2022-06-28T16:47:00Z"
		}
	}
}), ae = n({
	route: (e) => `/bulk-actions/${e.id}/cancel`,
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/api\/bulk-actions\/(.+)\/cancel$/,
		mock: {
			bulkActionId: "018ee64c-d146-79a8-9c07-9798d1462fd8",
			cancelledEntitiesCount: 10,
			message: "Successfully cancelled 10 pending entities"
		}
	}
}), l = "paymentSettings", oe = t({
	route: () => "/payments/settings",
	queryKey: [l],
	mocking: {
		match: /\/api\/payments\/settings$/,
		mock: {
			id: "123",
			failureNotifications: {
				merchantNotifications: "SEND_NOTIFICATIONS",
				customerNotifications: "DO_NOT_SEND_NOTIFICATIONS"
			}
		}
	}
}), u = "taxCategories", se = t({
	route: (e) => `/tax-categories${s(e)}`,
	queryKey: [u],
	mocking: {
		match: /\/api\/tax-categories(\?(.*))?$/,
		mock: {
			items: [{
				id: "3271ca41-d538-404f-a15f-25856a37fb88",
				versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
				version: 0,
				isPublished: !1,
				name: "EU Sales Taxes",
				description: "All sales taxes required for the EU",
				taxRates: [],
				isDefault: !1
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), ce = t({
	route: ({ id: e }) => `/tax-categories/${e}`,
	queryKey: [u],
	mocking: {
		match: /\/api\/tax-categories\/(.+)$/,
		mock: {
			id: "3271ca41-d538-404f-a15f-25856a37fb88",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 0,
			isPublished: !1,
			name: "EU Sales Taxes",
			description: "All sales taxes required for the EU",
			taxRates: [],
			isDefault: !1
		}
	}
}), le = n({
	route: () => "/tax-categories",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [u],
	mocking: {
		match: /\/api\/tax-categories$/,
		mock: {
			id: "3271ca41-d538-404f-a15f-25856a37fb88",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 0,
			isPublished: !1,
			name: "EU Sales Taxes",
			description: "All sales taxes required for the EU",
			taxRates: [],
			isDefault: !1
		}
	}
}), ue = n({
	route: ({ id: e }) => `/tax-categories/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [u],
	mocking: {
		match: /\/api\/tax-categories\/(.+)$/,
		mock: {
			id: "3271ca41-d538-404f-a15f-25856a37fb88",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 0,
			isPublished: !1,
			name: "EU Sales Taxes",
			description: "All sales taxes required for the EU",
			taxRates: [],
			isDefault: !1
		}
	}
}), de = n({
	route: ({ id: e }) => `/payments/settings/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [l],
	mocking: {
		match: /\/api\/payments\/settings\/(.+)$/,
		mock: {
			id: "settings-123",
			failureNotifications: {
				merchantNotifications: "SEND_NOTIFICATIONS",
				customerNotifications: "SEND_NOTIFICATIONS"
			}
		}
	}
}), fe = "products", pe = n({
	route: ({ id: e }) => `/products/${e}/archive`,
	method: "POST",
	invalidateQueries: [fe],
	mocking: {
		match: /\/api\/products\/(.+)\/archive$/,
		mock: {
			id: "prod-123",
			name: "Brand new shiny test product",
			label: "With a label",
			createdAt: "2024-06-20T14:41:06.95878Z",
			updatedAt: "2024-06-20T14:41:06.958802Z"
		}
	}
}), me = "billingProducts", he = t({
	route: (e) => `/billing-products${s(e)}`,
	queryKey: [me],
	mocking: {
		match: /\/api\/billing-products(\?(.*))?$/,
		mock: {
			items: [{
				id: "f409d651-c475-4142-aafd-a5d2bd74d4f9",
				name: "Dog tax",
				label: "Charge for not providing photos of your dog",
				sequenceAccountId: "683fe518-60c8-429f-9320-8aa7efc20bcc",
				createdAt: "2022-06-28T16:47:00Z",
				updatedAt: "2022-06-28T16:47:00Z",
				prices: [],
				integrationIds: []
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), ge = n({
	route: ({ id: e }) => `/tax-categories/${e}/versions`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [u],
	mocking: {
		match: /\/api\/tax-categories\/(.+)\/versions$/,
		mock: {
			id: "3271ca41-d538-404f-a15f-25856a37fb88",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 1,
			isPublished: !0,
			name: "EU Sales Taxes",
			description: "All sales taxes required for the EU",
			taxRates: [],
			isDefault: !1
		}
	}
}), _e = "billingSettings", ve = t({
	route: () => "/billing/settings",
	queryKey: [_e],
	mocking: {
		match: /\/api\/billing\/settings$/,
		mock: {
			id: "b102e007-f5d7-4b1a-8a1d-9a51135ae73b",
			autoIssueInvoices: "ALL"
		}
	}
}), ye = n({
	route: () => "/billing/settings",
	method: "PUT",
	body: (e) => JSON.stringify(e.body),
	invalidateQueries: [_e],
	mocking: {
		match: /\/api\/billing\/settings$/,
		mock: {
			id: "b102e007-f5d7-4b1a-8a1d-9a51135ae73b",
			autoIssueInvoices: "ALL"
		}
	}
}), be = "invoiceRenderSettings", d = "invoices", xe = "invoicesLite", f = "invoiceSettings", p = "invoiceGrid", m = "usageItemGroups", Se = "invoiceMerchantDetails", Ce = "invoiceCsvDownload", we = "invoicePdfDownload", Te = "invoiceBulkDownloadZip", Ee = "invoiceCurrencyConversions", h = {
	id: "inv-123",
	sequenceAccountId: "seq-123",
	status: "DRAFT",
	currency: "GBP",
	netTotal: "1000",
	grossTotal: "1000",
	totalTax: "0",
	customerId: "cus-123",
	customerEmails: ["beep@boop.com"],
	customerLegalCompanyName: "Test Co.",
	customerBillingAddress: {
		line1: "123 Fake St",
		town: "Springfield",
		postcode: "12345",
		country: "GB"
	},
	customerShippingAddress: {
		line1: "123 Fake St",
		town: "Springfield",
		postcode: "12345",
		country: "GB"
	},
	isCustomerArchived: !1,
	metadata: [{
		key: "string",
		value: "string"
	}],
	paymentStatus: "PAID",
	createdAt: "2024-01-05",
	updatedAt: "2024-01-05",
	creditNoteIds: [],
	linkedServices: [{
		externalId: "string",
		externalService: "Xero",
		externalUrl: "https://example.com",
		syncTime: "2024-01-05T12:00:00Z"
	}],
	accountingDate: "2024-02-01",
	customerTaxStatus: "TAX_EXEMPT",
	renderSettings: { paymentLinkDisplay: "HIDE_PAYMENT_LINK" }
}, De = n({
	route: (e) => `/invoices/${e.id}/draft`,
	method: "POST",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/api\/invoices\/(.+)\/draft$/,
		mock: h
	}
}), { updatedAt: Oe, ...ke } = h, Ae = n({
	route: ({ invoiceId: e }) => `/invoices/${e}`,
	method: "DELETE",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/api\/invoices\/(.+)$/,
		mock: ke
	}
}), je = n({
	route: ({ settingsId: e }) => `/payments/settings/invoices/${e}`,
	method: "DELETE",
	invalidateQueries: [f],
	mocking: {
		match: /\/api\/payments\/settings\/invoices\/(.+)$/,
		mock: {
			id: "123",
			sequenceAccountId: "seq-123",
			invoiceId: "inv-123",
			customerId: "cus-123",
			paymentProvider: "STRIPE"
		}
	}
}), Me = t({
	route: (e) => `/invoices/${e.id}`,
	queryKey: [d],
	mocking: {
		match: /\/api\/invoices\/(.+)$/,
		mock: {
			...h,
			billingRunId: "brr-123"
		}
	}
}), Ne = t({
	route: ({ id: e }) => `/payments/settings/invoices/for-invoice/${e}`,
	method: "GET",
	queryKey: [f],
	mocking: {
		match: /\/api\/payments\/settings\/invoices\/for-invoice\/(.+)$/,
		mock: {
			id: "123",
			sequenceAccountId: "seq-123",
			invoiceId: "inv-123",
			paymentProvider: "STRIPE"
		}
	}
}), Pe = t({
	route: () => "/invoices/render-settings",
	queryKey: [be],
	mocking: {
		match: /\/api\/invoices\/render-settings$/,
		mock: {
			id: "123",
			paymentLinkDisplay: "SHOW_PAYMENT_LINK"
		}
	}
}), g = "lineItems", _ = "allLineItems", Fe = t({
	route: ({ invoiceId: e, ...t }) => `/invoices/${e}/line-items${s(t)}`,
	queryKey: [g],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items(\?(.*))?$/,
		mock: {
			items: [{
				id: "af60cab3-812d-4250-a051-0fb7133a00c7",
				invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
				title: "Ferraris",
				description: "Red",
				quantity: "2",
				rate: "20000.10",
				taxRate: "0.2",
				servicePeriodStart: "2022-10-20T00:00:00Z",
				servicePeriodEnd: "2022-10-24T00:00:00Z",
				servicePeriod: {
					startDate: "2022-10-20",
					endDate: "2022-10-24"
				},
				index: 2,
				groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
				netTotal: "51.20",
				totalTax: "2.50",
				grossTotal: "101.23",
				priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
				rateDisplay: "ABSOLUTE",
				externalIds: [{
					key: "Xero",
					value: "123"
				}],
				revenueClassification: "EARNED",
				creditGrantId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), v = "lineItems", Ie = n({
	route: ({ invoiceId: e }) => `/invoices/${e}/line-items`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		d,
		v,
		p
	],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			servicePeriodStart: "2022-10-20T00:00:00Z",
			servicePeriodEnd: "2022-10-24T00:00:00Z",
			servicePeriod: {
				startDate: "2022-10-20",
				endDate: "2022-10-24"
			},
			index: 2,
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}],
			revenueClassification: "EARNED",
			creditGrantId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95"
		}
	}
}), Le = n({
	route: ({ invoiceId: e, id: t }) => `/invoices/${e}/line-items/${t}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		d,
		v,
		p
	],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items\/(.+)$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			servicePeriodStart: "2022-10-20T00:00:00Z",
			servicePeriodEnd: "2022-10-24T00:00:00Z",
			servicePeriod: {
				startDate: "2022-10-20",
				endDate: "2022-10-24"
			},
			index: 2,
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}],
			revenueClassification: "EARNED",
			creditGrantId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95"
		}
	}
}), Re = t({
	route: () => "/invoices-lite/for-ids",
	method: "POST",
	queryKey: [xe],
	body: (e) => JSON.stringify(e),
	mocking: {
		match: /\/invoices-lite\/for-ids$/,
		mock: { items: [
			{
				id: "123",
				success: !0,
				data: {
					id: "123",
					invoiceNumber: "INV00001",
					customerLegalCompanyName: "Adam co"
				}
			},
			{
				id: "456",
				success: !0,
				data: {
					id: "456",
					invoiceNumber: "INV00007",
					customerLegalCompanyName: "Adam co"
				}
			},
			{
				id: "789",
				success: !0,
				data: {
					id: "789",
					invoiceNumber: "INV00102",
					customerLegalCompanyName: "Aperture Science"
				}
			}
		] }
	}
}), y = "invoices", ze = "invoiceGrid", Be = "invoicesSummary", Ve = "invoicesListSummary", b = {
	id: "ba37a392-7054-4dae-ab37-6fee9e23fe06",
	sequenceAccountId: "af9b5988-1d7b-45f6-a188-326df5e59b24",
	status: "DRAFT",
	currency: "GBP",
	invoiceNumber: "INV2",
	dueDate: "2022-11-05",
	purchaseOrderNumber: "PO123",
	reference: "ref",
	customerEmails: ["customer@example.com"],
	customerLegalCompanyName: "Facebook",
	customerBillingAddress: {
		line1: "Flat 1",
		line2: "15 Yemen Road",
		town: "Yemen",
		state: "CA",
		postcode: "YE1 2YE",
		country: "YE"
	},
	customerShippingAddress: {
		line1: "742 Evergreen Terrace",
		line2: "",
		town: "Springfield",
		state: "CA",
		postcode: "12345",
		country: "US"
	},
	memo: "Thanks",
	paymentOptions: ["BANK_TRANSFER"],
	billingPeriod: {
		start: "2022-10-01",
		endInclusive: "2022-10-30"
	},
	customerId: "b3c0cf23-6717-4cdc-b190-acf8aa6ccd8a",
	totalTax: "2",
	netTotal: "12",
	grossTotal: "10",
	metadata: [{
		key: "example-label",
		value: "label-value"
	}],
	paymentStatus: "UNPAID",
	createdAt: "2022-10-30T00:00:00Z",
	updatedAt: "2022-10-30T00:00:00Z",
	creditNoteIds: ["941272d1-f840-4e16-b698-0cd455c81e0e"],
	linkedServices: [{
		externalId: "ID",
		externalService: "Xero",
		syncTime: "2022-06-28T16:47:00Z"
	}],
	merchantDetails: {
		address: {
			line1: "Flat 1",
			line2: "123 Fake Street",
			town: "New York",
			state: "NY",
			postcode: "AB1 2EF",
			country: "US"
		},
		phoneNumber: "0800001066",
		email: "donald@example.com",
		taxId: "TAX",
		iban: "GB33BUKB20201555555555",
		ukAccountDetails: {
			sortCode: "123456",
			accountNumber: "12345678"
		},
		usAchDetails: {
			accountNumber: "12345678",
			accountName: "John Doe",
			bankName: "Chase",
			bankRoutingNumber: "123456789"
		},
		usWireDetails: {
			accountNumber: "12345678",
			accountName: "John Doe",
			bankName: "Chase",
			bankRoutingNumber: "123456789",
			swiftCode: "CHASUS33",
			bankAddress: {
				line1: "JP Morgan Chase",
				town: "New York City",
				state: "NY",
				postcode: "10017",
				country: "US"
			}
		},
		legalCompanyName: "The Merchant",
		customFields: [],
		includeBeneficiaryAddressInPaymentDetails: !1
	},
	accountingDate: "2022-10-05",
	customerTaxStatus: "TAXED",
	renderSettings: { paymentLinkDisplay: "HIDE_PAYMENT_LINK" },
	isCustomerArchived: !1
}, He = n({
	route: ({ id: e }) => `/invoices/${e}/finalize-and-send`,
	method: "POST",
	invalidateQueries: [y],
	mocking: {
		match: /\/api\/invoices\/(.+)\/finalize-and-send$/,
		mock: b
	}
}), Ue = n({
	route: ({ id: e }) => `/invoices/${e}/finalize`,
	method: "POST",
	invalidateQueries: [y],
	mocking: {
		match: /\/api\/invoices\/(.+)\/finalize$/,
		mock: b
	}
}), We = n({
	route: () => "/invoices/merge",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [
		d,
		c,
		p
	],
	mocking: {
		match: /\/api\/invoices\/merge$/,
		mock: b
	}
}), Ge = n({
	route: () => "/invoices/finalize-and-send",
	body: ({ invoiceIds: e }) => JSON.stringify({ invoiceIds: e }),
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/invoices\/finalize-and-send$/,
		mock: {
			id: "e007e884-5100-4183-8355-4771865cb4dd",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "FINALISE_AND_SEND_INVOICES",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), Ke = n({
	route: () => "/invoices/finalize",
	body: ({ invoiceIds: e }) => JSON.stringify({ invoiceIds: e }),
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/invoices\/finalize$/,
		mock: {
			id: "e007e884-5100-4183-8355-4771865cb4dd",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "FINALISE_INVOICES",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), qe = n({
	route: () => "/payments/settings/invoices",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [f, d],
	mocking: {
		match: /\/api\/payments\/settings\/invoices$/,
		mock: {
			id: "123",
			sequenceAccountId: "seq-123",
			invoiceId: "inv-123",
			customerId: "cus-123",
			paymentProvider: "STRIPE"
		}
	}
}), Je = n({
	route: () => "/invoices/recalculate",
	body: ({ invoiceIds: e }) => JSON.stringify({ invoiceIds: e }),
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/invoices\/recalculate$/,
		mock: void 0
	}
}), Ye = n({
	route: () => "/invoices/send",
	body: ({ invoiceIds: e }) => JSON.stringify({ invoiceIds: e }),
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/invoices\/send$/,
		mock: {
			id: "e007e884-5100-4183-8355-4771865cb4dd",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "SEND_INVOICES",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), Xe = n({
	route: () => "/invoices/download",
	body: ({ invoiceIds: e }) => JSON.stringify({ invoiceIds: e }),
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/invoices\/download$/,
		mock: {
			id: "e007e884-5100-4183-8355-4771865cb4dd",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "DOWNLOAD_INVOICES",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), Ze = t({
	route: ({ bulkActionId: e }) => `/invoices/bulk-downloads/${e}`,
	config: { responseTransform: (e) => e.blob() },
	queryKey: [Te],
	mocking: {
		match: /\/invoices\/bulk-downloads\/[^\/]+$/,
		mock: new Blob([""], { type: "application/zip" })
	}
}), Qe = n({
	route: () => "/invoices/void",
	body: ({ invoiceIds: e }) => JSON.stringify({ invoiceIds: e }),
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/invoices\/void$/,
		mock: {
			id: "e007e884-5100-4183-8355-4771865cb4dd",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "VOID_INVOICES",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), $e = n({
	route: () => "/invoices/delete",
	body: ({ invoiceIds: e }) => JSON.stringify({ invoiceIds: e }),
	method: "POST",
	invalidateQueries: [
		d,
		c,
		p
	],
	mocking: {
		match: /\/invoices\/delete$/,
		mock: {
			id: "e007e884-5100-4183-8355-4771865cb4dd",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "DELETE_INVOICES",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), et = n({
	route: () => "/invoices/mark-as-sent",
	body: ({ invoiceIds: e }) => JSON.stringify({ invoiceIds: e }),
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/invoices\/mark-as-sent$/,
		mock: {
			id: "e007e884-5100-4183-8355-4771865cb4dd",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "MARK_INVOICES_AS_SENT",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), tt = n({
	route: ({ id: e }) => `/invoices/${e}`,
	method: "PUT",
	body: (e) => JSON.stringify(e.body),
	invalidateQueries: [d, p],
	mocking: {
		match: /\/api\/invoices\/(.+)$/,
		mock: h
	}
}), nt = n({
	route: ({ settingsId: e }) => `/payments/settings/invoices/${e}`,
	method: "PUT",
	body: ({ paymentProvider: e }) => JSON.stringify({ paymentProvider: e }),
	invalidateQueries: [f],
	mocking: {
		match: /\/api\/payments\/settings\/invoices\/(.+)$/,
		mock: {
			id: "123",
			sequenceAccountId: "seq-123",
			invoiceId: "inv-123",
			customerId: "cus-123",
			paymentProvider: "STRIPE"
		}
	}
}), rt = n({
	route: ({ id: e }) => `/invoices/render-settings/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [be],
	mocking: {
		match: /\/api\/invoices\/render-settings\/(.+)$/,
		mock: {
			id: "123",
			paymentLinkDisplay: "SHOW_PAYMENT_LINK"
		}
	}
}), it = n({
	route: () => "/invoices/payment-status",
	body: ({ invoiceIds: e, paymentStatus: t }) => JSON.stringify({
		invoiceIds: e,
		paymentStatus: t
	}),
	method: "PUT",
	invalidateQueries: [c, d],
	mocking: {
		match: /\/invoices\/payment-status$/,
		mock: void 0
	}
}), at = n({
	route: ({ id: e }) => `/invoices/${e}/send`,
	method: "POST",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/invoices\/(.+)\/send$/,
		mock: h
	}
}), ot = n({
	route: ({ id: e }) => `/invoices/${e}/finalize-and-send`,
	method: "POST",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/invoices\/(.+)\/finalize-and-send$/,
		mock: h
	}
}), st = "lineItemGroups", x = "allLineItemGroups", ct = "creditNotes", lt = "creditNoteApplicationEligibility", ut = "creditNotesDownload", dt = "creditNoteLineItems", ft = "creditNoteLineItemGroups", pt = n({
	route: ({ id: e }) => `/invoices/${e}/recalculate`,
	method: "POST",
	invalidateQueries: [
		d,
		p,
		_,
		x,
		m,
		ct
	],
	mocking: {
		match: /\/invoices\/(.+)\/recalculate$/,
		mock: h
	}
}), mt = n({
	route: ({ id: e }) => `/invoices/${e}/void`,
	method: "POST",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/invoices\/(.+)\/void$/,
		mock: h
	}
}), ht = n({
	route: ({ id: e }) => `/invoices/${e}/finalize`,
	method: "POST",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/invoices\/(.+)\/finalize$/,
		mock: h
	}
}), gt = n({
	route: ({ id: e }) => `/invoices/${e}/mark-as-sent`,
	method: "POST",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/invoices\/(.+)\/mark-as-sent$/,
		mock: h
	}
}), _t = n({
	route: ({ id: e }) => `/invoices/${e}/send-payment-reminder`,
	method: "POST",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/invoices\/(.+)\/send-payment-reminder$/,
		mock: h
	}
}), vt = n({
	route: ({ invoiceId: e, lineItemGroupId: t }) => `/invoices/${e}/line-item-groups/${t}`,
	method: "DELETE",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-item-groups\/(.+)$/,
		mock: {
			id: "4639a112-f821-4bc1-bc2d-6f9ece5b7c0f",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Users",
			description: "Charges for users",
			index: 2,
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			taxCategory: {
				id: "28227c88-6dba-455f-9b30-b9c76957e610",
				name: "VAT"
			}
		}
	}
}), yt = n({
	route: ({ invoiceId: e, lineItemId: t }) => `/invoices/${e}/line-items/${t}`,
	method: "DELETE",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items\/(.+)$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			servicePeriodStart: "2022-10-20T00:00:00Z",
			servicePeriodEnd: "2022-10-24T00:00:00Z",
			servicePeriod: {
				startDate: "2022-10-20",
				endDate: "2022-10-24"
			},
			index: 2,
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}],
			revenueClassification: "EARNED",
			creditGrantId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			productId: "dd55bf30-3b97-4644-a9fc-b15e0f59a110"
		}
	}
}), bt = n({
	route: ({ id: e, testEmail: t }) => `/invoices/${e}/send/${t}`,
	method: "POST",
	invalidateQueries: [d, p],
	mocking: {
		match: /\/invoices\/(.+)\/send\/(.+)$/,
		mock: h
	}
}), xt = t({
	route: (e) => `/invoices/invoices-grid${s({
		invoiceCurrency: e?.invoiceCurrency,
		customerIds: e?.customerIds?.join(","),
		invoiceStatuses: e?.invoiceStatuses?.join(","),
		paymentStatuses: e?.paymentStatuses?.join(",")
	})}`,
	queryKey: [p],
	mocking: {
		match: /\/invoices\/invoices-grid(\?(.*))?$/,
		mock: {
			customerDetails: [{
				customerId: "4ecc7384-e25e-459d-b811-fb5f3ae73923",
				legalName: "Saas Corp",
				total: "600",
				netTotal: "400",
				monthDetails: [{
					month: "2023-09-01",
					total: "300",
					netTotal: "200",
					invoiceIds: ["b78f0591-afcc-43bc-851f-2288aa25b07b"]
				}, {
					month: "2023-10-01",
					total: "300",
					netTotal: "200",
					invoiceIds: ["227b8ff9-42ad-47f8-bfa5-9e5760d4d5d8"]
				}]
			}, {
				customerId: "a0bc49b1-8e9a-4995-af73-5db2f9bd494b",
				legalName: "Hermanos Cafeteros Inc.",
				total: "600",
				netTotal: "400",
				monthDetails: [{
					month: "2023-09-01",
					total: "300",
					netTotal: "200",
					invoiceIds: ["12e4c680-a33d-4440-b01b-6e259e0a51d4"]
				}, {
					month: "2023-10-01",
					total: "300",
					netTotal: "200",
					invoiceIds: ["c82c7f82-2d76-49b4-832b-c9bb1969a5c6", "1b4d180d-ae8d-413c-9a97-08a7a85a2980"]
				}]
			}],
			accountTotal: "1200",
			accountNetTotal: "800",
			monthDetails: [{
				month: "2023-09-01",
				total: "600",
				netTotal: "400",
				invoiceIds: ["b78f0591-afcc-43bc-851f-2288aa25b07b", "12e4c680-a33d-4440-b01b-6e259e0a51d4"]
			}, {
				month: "2023-10-01",
				total: "600",
				netTotal: "400",
				invoiceIds: [
					"227b8ff9-42ad-47f8-bfa5-9e5760d4d5d8",
					"c82c7f82-2d76-49b4-832b-c9bb1969a5c6",
					"1b4d180d-ae8d-413c-9a97-08a7a85a2980"
				]
			}]
		}
	}
}), S = {
	line1: "7500 Bluewater Rd NW",
	town: "Albuquerque",
	state: "NY",
	postcode: "87121",
	country: "US"
}, C = {
	id: "created-invoice-customer-id",
	createdAt: "2021-01-02T10:55:00Z",
	organizations: [],
	legalName: "Fintech Payment Processing",
	addresses: [{
		purposes: ["BILLING"],
		address: S
	}],
	integrationIds: [],
	taxStatus: "TAXED",
	contacts: []
}, w = {
	id: "created-invoice-id",
	sequenceAccountId: "created-sequence-account-id",
	status: "DRAFT",
	currency: "GBP",
	netTotal: "1000",
	grossTotal: "1000",
	totalTax: "0",
	customerId: C.id,
	customerEmails: ["beep@boop.com"],
	customerLegalCompanyName: C.legalName,
	customerBillingAddress: S,
	customerShippingAddress: S,
	customerTaxStatus: C.taxStatus,
	isCustomerArchived: !1,
	metadata: [],
	paymentStatus: "PAID",
	createdAt: "2024-01-05",
	updatedAt: "2024-01-05",
	creditNoteIds: [],
	linkedServices: [],
	accountingDate: "2024-02-01",
	renderSettings: { paymentLinkDisplay: "HIDE_PAYMENT_LINK" }
}, St = (e) => e === w.id, Ct = {
	convertInvoiceToDraft: De,
	deleteInvoice: Ae,
	deleteInvoiceSettings: je,
	getInvoice: Me,
	getInvoiceSettingsForInvoice: Ne,
	getInvoicesRenderSettings: Pe,
	getLineItems: Fe,
	postLineItem: Ie,
	putLineItem: Le,
	listInvoicesLite: Re,
	postMergeInvoices: We,
	postInvoiceSettings: qe,
	putInvoice: tt,
	putInvoiceSettings: nt,
	putInvoicesRenderSettings: rt,
	postSendInvoice: at,
	postFinalizeAndSendInvoice: ot,
	postRecalculateInvoice: pt,
	postVoidInvoice: mt,
	postFinalizeInvoice: ht,
	postMarkAsSentInvoice: gt,
	postSendPaymentReminderForInvoice: _t,
	deleteInvoiceLineItemGroup: vt,
	deleteInvoiceLineItem: yt,
	postSendTestInvoice: bt,
	getInvoicesGrid: xt,
	getInvoiceUsageItemGroups: t({
		route: ({ invoiceId: e }) => `/invoices/${e}/usage-item-groups`,
		queryKey: [m],
		mocking: {
			match: /\/invoices\/(.+)\/usage-item-groups$/,
			mock: { items: [{
				id: "1aaeac35-cdc3-4adb-a741-5fa4816619ad",
				invoiceId: "invoice-1",
				title: "Successful API Calls",
				items: [{
					id: "cf8ad70f-f79a-4803-a41f-9a0b436c865a",
					invoiceId: "6cedbb5e-4f77-4217-b8d4-020e7e4d33c9",
					title: "Eldest Child",
					value: "150",
					groupedValues: [],
					lineItemGroupId: "f4457a3c-a0f2-44ea-9c8d-548fa1298626",
					usageItemGroupId: "1aaeac35-cdc3-4adb-a741-5fa4816619ad"
				}, {
					id: "f00fcb1a-76ff-44d9-b8c3-b444e554cc9c",
					invoiceId: "6cedbb5e-4f77-4217-b8d4-020e7e4d33c9",
					title: "Youngest Child",
					value: "300",
					groupedValues: [],
					lineItemGroupId: "f4457a3c-a0f2-44ea-9c8d-548fa1298626",
					usageItemGroupId: "1aaeac35-cdc3-4adb-a741-5fa4816619ad"
				}]
			}] }
		},
		demoModeHandler: (e) => {
			if (St(e.invoiceId)) return Promise.resolve({
				data: { items: [] },
				error: !1,
				res: new Response()
			});
		}
	}),
	postCalculateInvoiceTotals: n({
		route: () => "/invoices-totals",
		method: "POST",
		body: ({ lineItems: e }) => JSON.stringify({ lineItems: e }),
		invalidateQueries: [],
		mocking: {
			match: /\/invoices-totals$/,
			mock: {
				total: {
					netTotal: "200000",
					totalTax: "10",
					grossTotal: "22000"
				},
				lineItemTotals: [{
					id: "af60cab3-812d-4250-a051-0fb7133a00c7",
					total: {
						netTotal: "200000",
						totalTax: "10",
						grossTotal: "22000"
					}
				}],
				lineItemGroupTotals: [{
					id: "941272d1-f840-4e16-b698-0cd455c81e0e",
					total: {
						netTotal: "200000",
						totalTax: "10",
						grossTotal: "22000"
					}
				}]
			}
		}
	}),
	getUsageDataForInvoiceLineItemGroup: t({
		route: ({ invoiceId: e, lineItemGroupId: t }) => `/invoices/${e}/line-item-groups/${t}/usage-data`,
		queryKey: [m],
		mocking: {
			match: /\/invoices\/(.+)\/line-item-groups\/(.+)\/usage-data$/,
			mock: { data: {
				usageStart: "2023-02-01",
				usageEnd: "2023-04-30",
				metricName: "API Calls",
				metricId: "27ba4761-7573-41c5-b780-2993b2c254f7",
				total: "35",
				usageData: [
					{
						periodStart: "2023-02-01",
						amount: "10",
						cumulativeAmount: "10"
					},
					{
						periodStart: "2023-03-01",
						amount: "15",
						cumulativeAmount: "25"
					},
					{
						periodStart: "2023-04-01",
						amount: "10",
						cumulativeAmount: "35"
					}
				]
			} }
		}
	}),
	getInvoiceMerchantDetails: t({
		route: (e) => `/invoice-merchant-details${s(e)}`,
		method: "GET",
		queryKey: [Se],
		mocking: {
			match: /\/api\/invoice-merchant-details(\?(.*))?$/,
			mock: {
				address: {
					line1: "Flat 1",
					line2: "123 Fake Street",
					town: "New York",
					state: "NY",
					postcode: "AB1 2EF",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "123456",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [],
				includeBeneficiaryAddressInPaymentDetails: !1
			}
		}
	}),
	getInvoiceCurrencyConversions: t({
		route: (e) => `/invoices/${e.id}/currency-conversions`,
		method: "GET",
		queryKey: [d, Ee],
		mocking: {
			match: /\/api\/invoices\/(.+)\/currency-conversions$/,
			mock: { items: [{
				id: "018d9d70-8eb1-7ccf-b9d1-dfd0b374f4a3",
				invoiceId: "018d9d72-8eb1-7ccf-b9d1-dfd0b374f4a5",
				currency: "USD",
				totalTax: "25.00",
				netTotal: "125.00",
				grossTotal: "150.00",
				exchangeRate: "0.8"
			}] }
		}
	}),
	postInvoice: n({
		route: () => "/invoices",
		method: "POST",
		body: (e) => JSON.stringify(e),
		invalidateQueries: [d, p],
		mocking: {
			match: /\/api\/invoices$/,
			mock: h
		},
		demoModeHandler: () => Promise.resolve({
			data: w,
			error: !1,
			res: new Response()
		})
	}),
	putInvoicePaymentStatus: n({
		route: ({ invoiceId: e }) => `/invoices/${e}/payment-status`,
		method: "PUT",
		body: ({ invoiceId: e, ...t }) => JSON.stringify(t),
		invalidateQueries: [d, p],
		mocking: {
			match: /\/api\/invoices\/(.+)\/payment-status$/,
			mock: h
		}
	}),
	getInvoicesCsvDownload: t({
		route: (e) => `/invoices/invoices-csv${typeof e == "string" ? `?${e}` : s(e)}`,
		config: { responseTransform: (e) => e.blob() },
		queryKey: [Ce],
		mocking: {
			match: /\/api\/invoices\/invoices-csv(\?(.*))?$/,
			mock: new Blob([""], { type: "text/csv" })
		}
	}),
	getInvoicePdf: t({
		route: ({ id: e }) => `/invoices/${e}/download`,
		config: { responseTransform: (e) => e.blob() },
		queryKey: [we],
		mocking: {
			match: /\/api\/invoices\/[^\/]+\/download$/,
			mock: new Blob([""], { type: "application/pdf" })
		}
	}),
	getInvoiceBulkDownloadZip: Ze,
	getInvoicesGridCsvDownload: t({
		route: (e) => `/invoices/invoices-grid-csv${s(e)}`,
		config: { responseTransform: (e) => e.blob() },
		queryKey: [Ce],
		mocking: {
			match: /\/api\/invoices\/invoices-grid-csv(\?(.*))?$/,
			mock: new Blob([""], { type: "text/csv" })
		}
	}),
	postRetryInvoicePayment: n({
		route: ({ id: e }) => `/payments/invoices/${e}/retry`,
		method: "POST",
		invalidateQueries: [d],
		mocking: {
			match: /\/api\/payments\/invoices\/(.+)\/retry$/,
			mock: void 0
		}
	}),
	patchSentInvoice: n({
		route: ({ id: e }) => `/invoices/${e}/sent`,
		method: "PATCH",
		body: (e) => JSON.stringify(e.body),
		invalidateQueries: [d, p],
		mocking: {
			match: /\/api\/invoices\/(.+)\/sent$/,
			mock: h
		}
	}),
	postRecalculateMultipleInvoices: Je,
	postFinalizeAndSendMultipleInvoices: Ge,
	postFinalizeMultipleInvoices: Ke,
	postSendMultipleInvoices: Ye,
	postDownloadMultipleInvoices: Xe,
	postVoidMultipleInvoices: Qe,
	postDeleteMultipleInvoices: $e,
	putUpdatePaymentStatusMultipleInvoices: it,
	postMarkAsSentMultipleInvoices: et
}, T = "credit-grants", wt = {
	postCreditGrant: n({
		route: () => "/credits",
		method: "POST",
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [T],
		mocking: {
			match: /\/api\/credits$/,
			mock: {
				id: "746fc7f2-8098-4fe7-953c-7d51c580a126",
				sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6",
				customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				name: "On-boarding Credits",
				creditUnitType: "CURRENCY",
				currency: "GBP",
				metricId: "f092246c-6b90-4106-bcca-304ccf06bf45",
				amount: 10,
				costOfCredit: 10,
				effectiveDate: "2023-01-01",
				expiryDate: "2023-01-31",
				createdAt: "2022-10-07T14:12:08.826121Z",
				integrationIds: [{
					service: "Xero",
					id: "74ed2615-4730-49ab-9445-74f31723a206",
					isPending: !1
				}]
			}
		}
	}),
	postCustomerCreditGrant: n({
		route: () => "/credit-grants",
		method: "POST",
		body: ({ body: e }) => JSON.stringify(e),
		headers: ({ idempotencyKey: e }) => ({ "Idempotency-Key": e ?? crypto.randomUUID() }),
		invalidateQueries: [T],
		mocking: {
			match: /\/api\/credit-grants$/,
			mock: {
				id: "0199ca8a-e7e8-73b3-bd69-a316a23231d3",
				sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6",
				customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				scope: "CUSTOMER",
				name: "Onboarding credit",
				creditUnitType: "CURRENCY",
				currency: "GBP",
				amount: 500,
				availableBalance: 0,
				state: {
					issuance: "PENDING",
					validity: "CURRENT"
				},
				costOfCredit: 400,
				effectiveDate: "2026-01-01",
				expiryDate: "2026-12-31",
				createdAt: "2026-01-01T10:00:00Z",
				updatedAt: "2026-01-01T10:00:00Z",
				grantRefreshFrequency: "NONE",
				billingFrequency: "ONE_TIME",
				rolloverMode: "NONE",
				restrictToPrices: [],
				integrationIds: []
			}
		}
	}),
	getCreditGrantsForCustomer: t({
		route: ({ customerId: e }) => `/credits/${e}/grants`,
		queryKey: [T, "credit-grants-for-customer"],
		mocking: {
			match: /\/api\/credits\/(.*)\/grants$/,
			mock: { items: [{
				id: "0184421a-8202-70ea-a729-30308a40bbf7",
				name: "credit-grant-1",
				grantAmount: 100,
				balance: 50,
				issueDate: "2022-06-28",
				expiryDate: "2022-07-28"
			}] }
		}
	}),
	getCreditGrantBalancesForCustomer: t({
		route: ({ customerId: e }) => `/credits/${e}/balances`,
		queryKey: [T, "credit-grant-balances"],
		mocking: {
			match: /\/api\/credits\/(.*)\/balances$/,
			mock: { items: [{
				id: "6587e308-ab0d-4a58-8cc1-1d168490de7b",
				type: "CASH",
				name: "Credits",
				balance: "50",
				grants: [{
					id: "5a0faea3-7ad5-4a83-a420-09bb6576f7e6",
					sequenceAccountId: "a507e782-d26b-4d34-92b9-aacd1667e1f0",
					customerId: "eabb3196-9c73-4c0d-b508-d3c4fc7b2cbb",
					type: "CASH",
					currency: "GBP",
					metricId: "b84f5290-fe95-4c6f-bedc-477700125265",
					name: "GBP",
					originalAmount: "10",
					currentBalance: "1",
					expiryDate: "2024-01-02",
					costOfCredit: "10",
					taxRateId: "b3c37ea3-96bb-44fb-baed-01eb38d3328e",
					effectiveDate: "2024-01-01",
					createdAt: "2024-01-01T12:00:00Z"
				}],
				transactions: [{
					id: "c770d296-ef09-459b-b8dd-42c334e00dab",
					grantId: "5a0faea3-7ad5-4a83-a420-09bb6576f7e6",
					reason: "because",
					invoiceId: "c6864c69-42a3-4966-8c22-1c56d7375a05",
					billingRunId: "e95256be-08e7-4585-b3c7-fa9928aacd90",
					type: "CREDIT",
					amount: "10",
					date: "2024-01-01"
				}]
			}] }
		}
	}),
	getAllCreditGrants: t({
		route: ({ limit: e = 100, ...t } = {}) => `/credits/filtered${s({
			limit: e,
			...t
		})}`,
		queryKey: [T, "all-credit-grants"],
		mocking: {
			match: /\/api\/credits\/filtered(\?(.*))?$/,
			mock: {
				items: [{
					id: "746fc7f2-8098-4fe7-953c-7d51c580a126",
					sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6",
					customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
					name: "On-boarding Credits",
					creditUnitType: "CURRENCY",
					currency: "GBP",
					metricId: "f092246c-6b90-4106-bcca-304ccf06bf45",
					amount: 10,
					costOfCredit: 10,
					taxRateId: "179d1ab3-cc96-48e2-9310-067b0b42d47c",
					effectiveDate: "2023-01-01",
					expiryDate: "2023-01-31",
					createdAt: "2022-10-07T14:12:08.826121Z"
				}],
				pagination: {
					after: "",
					before: "",
					totalResultSize: 1
				}
			}
		}
	}),
	deleteCreditGrant: n({
		route: ({ id: e }) => `/credits/${e}`,
		method: "DELETE",
		invalidateQueries: [T],
		mocking: {
			match: /\/api\/credits\/[^\/]+$/,
			mock: {
				id: "746fc7f2-8098-4fe7-953c-7d51c580a126",
				sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6",
				customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				name: "On-boarding Credits",
				creditUnitType: "CURRENCY",
				currency: "GBP",
				metricId: "f092246c-6b90-4106-bcca-304ccf06bf45",
				amount: 10,
				costOfCredit: 10,
				effectiveDate: "2023-01-01",
				expiryDate: "2023-01-31",
				createdAt: "2022-10-07T14:12:08.826121Z"
			}
		}
	})
}, Tt = "schedules-csv-download", E = "billingSchedules", D = "billingSchedulesSettings", Et = "billingPreview", O = "billingScheduleCustomFieldKeys", Dt = t({
	route: ({ id: e }) => `/billing-schedules/${e}`,
	queryKey: [E],
	mocking: {
		match: /\/api\/billing-schedules\/(.+)/,
		mock: {
			id: "b102e007-f5d7-4b1a-8a1d-9a51135ae73b",
			customerId: "cca32597-b6b0-4499-9669-128aef8702e4",
			status: "ACTIVE",
			startDate: "2022-01-01",
			endDate: "2022-12-01",
			taxRates: [],
			autoIssueInvoices: !1,
			purchaseOrderNumber: "PO123",
			reference: "ref",
			label: "label",
			recurrenceDayOfMonth: 1,
			prices: [{
				id: "bc61d4b8-e9d6-4f4a-9bcf-f5dae874c730",
				productId: "f409d651-c475-4142-aafd-a5d2bd74d4f9",
				name: "Demo Product",
				currency: "GBP",
				structure: {
					pricePerUnit: "0.25",
					usageMetricId: "04c62961-04ba-48e6-b985-758bb7d3e712",
					isPricePercentage: !1,
					pricingType: "LINEAR"
				},
				billingFrequency: "MONTHLY",
				billingType: "IN_ARREARS",
				createdAt: "2022-06-28T16:47:00Z",
				integrationIds: [],
				customMetricParameters: [{
					parameterId: "94703530-1293-479b-bd37-ccad42fd9c8b",
					value: "10"
				}],
				listPriceId: "b4d7e884-e007-4183-8355-4771865c5100"
			}],
			createdAt: "2022-06-28T16:47:00Z",
			phases: [{
				id: "6dc54805-0ac8-4f17-9341-4d3f2db9dcd8",
				priceIds: ["6dc54805-0ac8-4f17-9341-4d3f2db9dcd8"],
				startDate: "2022-01-01",
				endDate: "2022-06-30",
				name: "Phase name",
				externalContractRef: "ACME-2022-MSA",
				discounts: [{
					id: "discount-1",
					restrictToPrices: ["6dc54805-0ac8-4f17-9341-4d3f2db9dcd8"],
					type: "PERCENTAGE",
					amount: .15,
					message: "15% Discount",
					separateLineItem: !0,
					seatDiscountType: "ALL_SEATS"
				}],
				minimums: [{
					id: "minimum-1",
					amount: 100,
					restrictToPrices: ["6dc54805-0ac8-4f17-9341-4d3f2db9dcd8"]
				}],
				recurrencePreference: "CONTINUE_FROM_PREVIOUS_PHASE",
				phasePriceMetadata: [],
				contractReferences: [{
					type: "NETSUITE",
					value: "ACME-2022-MSA",
					label: "ACME-2022-MSA",
					url: null
				}]
			}],
			archivedAt: "2022-06-28T16:47:00Z",
			rollUpBilling: !1,
			defaultDueDateDays: 30,
			memo: "Example billing schedule",
			integrationIds: [],
			attachmentAssets: [],
			contractId: "0194d091-f65b-7b98-b75f-a923aa0f5b1a",
			customFields: {
				region: "EMEA",
				department: "Finance"
			}
		}
	}
}), Ot = t({
	route: () => "/billing-schedule-custom-field-keys",
	queryKey: [O],
	mocking: {
		match: /\/api\/billing-schedule-custom-field-keys$/,
		mock: { items: ["region", "department"] }
	}
}), kt = t({
	queryKey: [E],
	route: (e) => `/billing-schedules${s(e ?? {})}`,
	mocking: {
		match: /\/api\/billing-schedules(\?(.*))?$/,
		mock: {
			items: [{
				id: "schedule-1",
				customerId: "customer-1",
				status: "COMPLETED",
				phases: [{
					id: "test-phase",
					priceIds: ["test-price"],
					startDate: "2022-01-01",
					endDate: "2022-01-31",
					discounts: [{
						id: "test-discount",
						restrictToPrices: ["test-price"],
						type: "PERCENTAGE",
						amount: 10,
						message: "test-message",
						seatDiscountType: "ALL_SEATS"
					}],
					minimums: [{
						id: "test-minimum",
						restrictToPrices: ["test-price"],
						amount: 10
					}],
					recurrencePreference: "RESET",
					contractReferences: [],
					phasePriceMetadata: [{
						priceId: "test-price",
						arrCalculation: "INCLUDE"
					}]
				}],
				prices: [{
					id: "test-price",
					productId: "test-product",
					name: "Test price",
					currency: "GBP",
					structure: {
						pricePerUnit: "0.25",
						usageMetricId: "04c62961-04ba-48e6-b985-758bb7d3e712",
						isPricePercentage: !1,
						pricingType: "LINEAR"
					},
					billingFrequency: "MONTHLY",
					billingType: "IN_ARREARS",
					createdAt: "2022-01-01T00:00:00Z",
					integrationIds: [],
					customMetricParameters: []
				}],
				autoIssueInvoices: !1,
				purchaseOrderNumber: "test-purchase-order",
				reference: "test-reference",
				label: "test-label",
				recurrenceDayOfMonth: 1,
				rollUpBilling: !1,
				attachmentAssets: [],
				integrationIds: [],
				startDate: "2022-01-01",
				endDate: "2022-01-31",
				taxRates: [],
				createdAt: "2022-01-01T00:00:00Z",
				customFields: {
					region: "EMEA",
					department: "Finance"
				}
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), At = t({
	route: (e) => `/billing-schedules/billing-schedules-csv${s({
		customerId: e?.customerId,
		includeArchivedSchedules: e?.includeArchivedSchedules,
		billingScheduleStatus: e?.billingScheduleStatus,
		label: e?.label,
		includeCustomFields: e?.includeCustomFields?.join(",")
	})}`,
	config: { responseTransform: (e) => e.blob() },
	queryKey: [Tt],
	mocking: {
		match: /\/api\/billing-schedules\/billing-schedules-csv(\?(.*))?$/,
		mock: new Blob([""], { type: "text/csv" })
	}
}), jt = t({
	route: ({ billingScheduleId: e }) => `/payments/settings/billing-schedules/for-billing-schedule/${e}`,
	queryKey: [D],
	mocking: {
		match: /\/api\/payments\/settings\/billing-schedules\/for-billing-schedule\/(.+)/,
		mock: {
			id: "settings-1",
			billingScheduleId: "schedule-1",
			paymentProvider: "STRIPE",
			autoCharge: !1
		}
	}
}), Mt = "prices", k = "priceMetadata", Nt = n({
	route: () => "/billing-schedules",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		E,
		O,
		k,
		T
	],
	mocking: {
		match: /\/api\/billing-schedules$/,
		mock: {
			id: "schedule-1",
			endDate: "2022-01-31",
			prices: [],
			createdAt: "2022-01-01T00:00:00Z",
			customerId: "customer-1",
			status: "COMPLETED",
			integrationIds: [],
			phases: [{
				id: "test-phase",
				priceIds: ["test-price"],
				startDate: "2022-01-01",
				endDate: "2022-01-31",
				discounts: [{
					id: "test-discount",
					restrictToPrices: ["test-price"],
					type: "PERCENTAGE",
					amount: 10,
					message: "test-message",
					separateLineItem: !0,
					seatDiscountType: "ALL_SEATS"
				}],
				minimums: [{
					id: "test-minimum",
					restrictToPrices: ["test-price"],
					amount: 10
				}],
				recurrencePreference: "CONTINUE_FROM_PREVIOUS_PHASE",
				contractReferences: [],
				phasePriceMetadata: [{
					priceId: "test-price",
					arrCalculation: "INCLUDE"
				}]
			}],
			startDate: "2022-01-01",
			taxRates: [{
				priceId: "test-price",
				taxRateId: "test-tax-rate"
			}],
			autoIssueInvoices: !1,
			purchaseOrderNumber: "test-purchase-order",
			reference: "test-reference",
			label: "test-label",
			recurrenceDayOfMonth: 1,
			rollUpBilling: !1,
			defaultDueDateDays: 30,
			memo: "Example billing schedule",
			customFields: {
				region: "EMEA",
				department: "Finance"
			}
		}
	}
}), Pt = n({
	route: ({ id: e }) => `/billing-schedules/${e}/archive`,
	method: "POST",
	invalidateQueries: [E],
	mocking: {
		match: /\/api\/billing-schedules\/(.+)\/archive$/,
		mock: {
			customerId: "customer-1",
			endDate: "2022-01-31",
			integrationIds: [],
			status: "COMPLETED",
			phases: [{
				id: "test-phase",
				priceIds: ["test-price"],
				startDate: "2022-01-01",
				endDate: "2022-01-31",
				discounts: [{
					id: "test-discount",
					restrictToPrices: ["test-price"],
					type: "PERCENTAGE",
					amount: 10,
					message: "test-message",
					separateLineItem: !0,
					seatDiscountType: "ALL_SEATS"
				}],
				minimums: [{
					id: "test-minimum",
					restrictToPrices: ["test-price"],
					amount: 10
				}],
				recurrencePreference: "CONTINUE_FROM_PREVIOUS_PHASE",
				contractReferences: [],
				phasePriceMetadata: [{
					priceId: "test-price",
					arrCalculation: "INCLUDE"
				}]
			}],
			startDate: "2022-01-01",
			taxRates: [{
				priceId: "test-price",
				taxRateId: "test-tax-rate"
			}],
			autoIssueInvoices: !1,
			purchaseOrderNumber: "test-purchase-order",
			reference: "test-reference",
			label: "test-label",
			recurrenceDayOfMonth: 1,
			rollUpBilling: !1,
			id: "schedule-1",
			createdAt: "2022-01-01T00:00:00Z",
			prices: [],
			attachmentAssets: [{
				id: "test-asset-id",
				type: "IMAGE",
				format: "PDF",
				fileName: "my-image.png",
				fileSizeBytes: 12345,
				url: "https://assets.sequencehq.com/123/images/test-asset-id.png",
				createdBy: "upload-user-1",
				createdAt: "2025-03-11T00:00:00.000Z"
			}],
			customFields: {
				region: "EMEA",
				department: "Finance"
			}
		}
	}
}), Ft = t({
	route: () => "/billing-schedules/preview",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	queryKey: [Et],
	mocking: {
		match: /\/api\/billing-schedules\/preview$/,
		mock: { occurrences: [
			{
				start: "2022-01-01",
				end: "2022-01-31"
			},
			{
				start: "2022-02-01",
				end: "2022-02-28"
			},
			{
				start: "2022-03-01",
				end: "2022-03-31"
			}
		] }
	}
}), It = n({
	route: () => "/payments/settings/billing-schedules",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [D],
	mocking: {
		match: /\/api\/payments\/settings\/billing-schedules$/,
		mock: {
			id: "settings-1",
			billingScheduleId: "schedule-1",
			paymentProvider: "STRIPE",
			autoCharge: !1
		}
	}
}), Lt = t({
	route: () => "/billing-schedules/validate-taxes",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	queryKey: [],
	mocking: {
		match: /\/api\/billing-schedules\/validate-taxes/,
		mock: null
	}
}), Rt = n({
	route: ({ id: e }) => `/billing-schedules/${e}`,
	method: "PUT",
	body: (e) => JSON.stringify({
		...e.body,
		type: "PHASES"
	}),
	invalidateQueries: [
		E,
		O,
		k,
		T
	],
	mocking: {
		match: /\/api\/billing-schedules\/(.+)$/,
		mock: {
			customerId: "customer-1",
			endDate: "2022-01-31",
			status: "COMPLETED",
			integrationIds: [],
			phases: [{
				id: "test-phase",
				priceIds: ["test-price"],
				startDate: "2022-01-01",
				endDate: "2022-01-31",
				discounts: [{
					id: "test-discount",
					restrictToPrices: ["test-price"],
					type: "PERCENTAGE",
					amount: 10,
					message: "test-message",
					separateLineItem: !0,
					seatDiscountType: "ALL_SEATS"
				}],
				minimums: [{
					id: "test-minimum",
					restrictToPrices: ["test-price"],
					amount: 10
				}],
				recurrencePreference: "RESET",
				contractReferences: [],
				phasePriceMetadata: []
			}],
			startDate: "2022-01-01",
			taxRates: [{
				priceId: "test-price",
				taxRateId: "test-tax-rate"
			}],
			autoIssueInvoices: !1,
			purchaseOrderNumber: "test-purchase-order",
			reference: "test-reference",
			label: "test-label",
			recurrenceDayOfMonth: 1,
			rollUpBilling: !1,
			id: "schedule-1",
			createdAt: "2022-01-01T00:00:00Z",
			prices: [],
			attachmentAssets: [{
				id: "test-asset-id",
				type: "IMAGE",
				format: "PDF",
				fileName: "my-image.png",
				fileSizeBytes: 12345,
				url: "https://assets.sequencehq.com/123/images/test-asset-id.png",
				createdBy: "upload-user-1",
				createdAt: "2025-03-11T00:00:00.000Z"
			}],
			customFields: {
				region: "EMEA",
				department: "Finance"
			}
		}
	}
}), zt = n({
	route: ({ id: e }) => `/billing-schedules/${e}/activate`,
	method: "PUT",
	invalidateQueries: [E, T],
	mocking: {
		match: /\/api\/billing-schedules\/(.+)\/activate$/,
		mock: {
			customerId: "customer-1",
			endDate: "2022-01-31",
			integrationIds: [],
			status: "COMPLETED",
			phases: [{
				id: "test-phase",
				priceIds: ["test-price"],
				startDate: "2022-01-01",
				endDate: "2022-01-31",
				discounts: [{
					id: "test-discount",
					restrictToPrices: ["test-price"],
					type: "PERCENTAGE",
					amount: 10,
					message: "test-message",
					separateLineItem: !0,
					seatDiscountType: "ALL_SEATS"
				}],
				minimums: [{
					id: "test-minimum",
					restrictToPrices: ["test-price"],
					amount: 10
				}],
				recurrencePreference: "CONTINUE_FROM_PREVIOUS_PHASE",
				contractReferences: [],
				phasePriceMetadata: [{
					priceId: "test-price",
					arrCalculation: "EXCLUDE"
				}]
			}],
			startDate: "2022-01-01",
			taxRates: [{
				priceId: "test-price",
				taxRateId: "test-tax-rate"
			}],
			autoIssueInvoices: !1,
			purchaseOrderNumber: "test-purchase-order",
			reference: "test-reference",
			label: "test-label",
			recurrenceDayOfMonth: 1,
			rollUpBilling: !1,
			id: "schedule-1",
			createdAt: "2022-01-01T00:00:00Z",
			prices: [],
			attachmentAssets: [{
				id: "test-asset-id",
				type: "IMAGE",
				format: "PDF",
				fileName: "my-image.png",
				fileSizeBytes: 12345,
				url: "https://assets.sequencehq.com/123/images/test-asset-id.png",
				createdBy: "upload-user-1",
				createdAt: "2025-03-11T00:00:00.000Z"
			}],
			customFields: {
				region: "EMEA",
				department: "Finance"
			}
		}
	}
}), Bt = {
	getBillingSchedule: Dt,
	getBillingScheduleCustomFieldKeys: Ot,
	getBillingSchedules: kt,
	getBillingSchedulesCsvDownload: At,
	getBillingScheduleSettings: jt,
	postBillingSchedule: Nt,
	postBillingScheduleBillingPreview: Ft,
	postBillingScheduleSettings: It,
	postBillingScheduleValidateTaxes: Lt,
	putBillingSchedule: Rt,
	postBillingScheduleArchive: Pt,
	putBillingScheduleSettings: n({
		route: ({ id: e }) => `/payments/settings/billing-schedules/${e}`,
		method: "PUT",
		body: (e) => JSON.stringify(e.body),
		invalidateQueries: [D],
		mocking: {
			match: /\/api\/payments\/settings\/billing-schedules\/(.+)$/,
			mock: {
				id: "settings-1",
				billingScheduleId: "schedule-1",
				paymentProvider: "STRIPE",
				autoCharge: !1
			}
		}
	}),
	putBillingScheduleActivate: zt,
	postDuplicateBillingSchedule: n({
		route: ({ id: e }) => `/billing-schedules/${e}/duplicate`,
		body: ({ customerId: e }) => JSON.stringify({ customerId: e }),
		method: "POST",
		invalidateQueries: [E, T],
		mocking: {
			match: /\/api\/billing-schedules\/[^\/]+\/duplicate$/,
			mock: {
				id: "b102e007-f5d7-4b1a-8a1d-9a51135ae73b",
				customerId: "cca32597-b6b0-4499-9669-128aef8702e4",
				status: "ACTIVE",
				startDate: "2022-01-01",
				endDate: "2022-12-01",
				taxRates: [],
				autoIssueInvoices: !1,
				purchaseOrderNumber: "PO123",
				reference: "ref",
				label: "label",
				recurrenceDayOfMonth: 1,
				prices: [{
					id: "bc61d4b8-e9d6-4f4a-9bcf-f5dae874c730",
					productId: "f409d651-c475-4142-aafd-a5d2bd74d4f9",
					name: "Demo Product",
					currency: "GBP",
					structure: {
						pricePerUnit: "0.25",
						usageMetricId: "04c62961-04ba-48e6-b985-758bb7d3e712",
						isPricePercentage: !1,
						pricingType: "LINEAR"
					},
					billingFrequency: "MONTHLY",
					billingType: "IN_ARREARS",
					createdAt: "2022-06-28T16:47:00Z",
					updatedAt: "2022-06-28T16:47:00Z",
					integrationIds: [],
					customMetricParameters: [{
						parameterId: "94703530-1293-479b-bd37-ccad42fd9c8b",
						value: "10"
					}],
					listPriceId: "b4d7e884-e007-4183-8355-4771865c5100"
				}],
				createdAt: "2022-06-28T16:47:00Z",
				phases: [{
					id: "6dc54805-0ac8-4f17-9341-4d3f2db9dcd8",
					priceIds: ["6dc54805-0ac8-4f17-9341-4d3f2db9dcd8"],
					startDate: "2022-01-01",
					endDate: "2022-06-30",
					name: "Phase name",
					discounts: [{
						id: "test-discount",
						restrictToPrices: ["6dc54805-0ac8-4f17-9341-4d3f2db9dcd8"],
						type: "PERCENTAGE",
						amount: .15,
						message: "15% Discount",
						separateLineItem: !0,
						seatDiscountType: "ALL_SEATS"
					}],
					minimums: [{
						id: "test-minimum",
						amount: 100,
						restrictToPrices: ["6dc54805-0ac8-4f17-9341-4d3f2db9dcd8"]
					}],
					recurrencePreference: "CONTINUE_FROM_PREVIOUS_PHASE",
					contractReferences: [],
					phasePriceMetadata: []
				}],
				archivedAt: "2022-06-28T16:47:00Z",
				rollUpBilling: !1,
				integrationIds: [],
				attachmentAssets: [],
				contractId: "0194d091-f65b-7b98-b75f-a923aa0f5b1a",
				customFields: {
					region: "EMEA",
					department: "Finance"
				}
			}
		}
	})
}, A = "savedViews", Vt = {
	getSavedViews: t({
		route: () => "/saved-views",
		queryKey: [A],
		mocking: {
			match: /\/api\/saved-views(\?(.*))?$/,
			mock: { items: [{
				id: "saved-view-1",
				entityType: "INVOICES",
				name: "Saved View 1",
				activeFilters: [{
					paramName: "customerId",
					type: "multiSelect",
					values: ["01946a39-eaf0-7be0-a647-a19d3cfbb5ef"]
				}, {
					type: "datePreset",
					paramName: "due",
					preset: "TODAY",
					operator: "EQUALS"
				}],
				createdAt: "2025-01-28T00:00:00.000Z",
				updatedAt: "2025-01-28T00:00:00.000Z"
			}] }
		}
	}),
	postSavedView: n({
		route: () => "/saved-views",
		method: "POST",
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [A],
		mocking: {
			match: /\/api\/saved-views$/,
			mock: {
				id: "saved-view-2",
				entityType: "INVOICES",
				name: "Saved View 2",
				activeFilters: [{
					paramName: "invoicePaymentStatus",
					type: "multiSelect",
					values: ["PAID"]
				}, {
					paramName: "invoiceCurrency",
					type: "multiSelect",
					values: ["EUR"]
				}],
				createdAt: "2025-01-28T00:00:00.000Z",
				updatedAt: "2025-01-28T00:00:00.000Z"
			}
		}
	}),
	putSavedView: n({
		route: ({ id: e }) => `/saved-views/${e}`,
		method: "PUT",
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [A],
		mocking: {
			match: /\/api\/saved-views\/(.+)$/,
			mock: {
				id: "updated-saved-view",
				entityType: "INVOICES",
				name: "Updated Saved View",
				activeFilters: [
					{
						paramName: "invoicePaymentStatus",
						type: "multiSelect",
						values: ["PAID"]
					},
					{
						paramName: "invoiceCurrency",
						type: "multiSelect",
						values: ["EUR"]
					},
					{
						paramName: "invoiceStatus",
						type: "multiSelect",
						values: ["DRAFT"]
					}
				],
				createdAt: "2025-01-28T00:00:00.000Z",
				updatedAt: "2025-01-28T00:00:00.000Z"
			}
		}
	}),
	deleteSavedView: n({
		route: ({ id: e }) => `/saved-views/${e}`,
		method: "DELETE",
		invalidateQueries: [A],
		mocking: {
			match: /\/api\/saved-views\/(.+)$/,
			mock: {
				id: "deleted-saved-view",
				entityType: "INVOICES",
				name: "Deleted Saved View",
				activeFilters: [{
					paramName: "customerId",
					type: "multiSelect",
					values: ["01946a39-eaf0-7be0-a647-a19d3cfbb5ef"]
				}, {
					type: "datePreset",
					paramName: "due",
					preset: "TODAY",
					operator: "EQUALS"
				}],
				createdAt: "2025-01-28T00:00:00.000Z",
				updatedAt: "2025-01-28T00:00:00.000Z"
			}
		}
	})
}, j = "quote-templates", Ht = t({
	route: (e) => `/quote-templates${s(e)}`,
	queryKey: [j],
	mocking: {
		match: /\/api\/quote-templates(\?(.*))?$/,
		mock: {
			items: [{
				id: "1",
				title: "Test Quote Template",
				currency: "USD",
				presentation: [],
				dealType: "NEW_BUSINESS",
				createdAt: "2022-01-01T00:00:00Z",
				createdBy: "1",
				updatedAt: "2022-01-01T00:00:00Z"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Ut = t({
	route: ({ id: e }) => `/quote-templates/${e}`,
	queryKey: [j],
	mocking: {
		match: /\/api\/quote-templates\/(.+)$/,
		mock: {
			template: {
				id: "1",
				title: "Test Quote Template",
				currency: "USD",
				presentation: [],
				dealType: "NEW_BUSINESS",
				createdAt: "2022-01-01T00:00:00Z",
				createdBy: "1",
				updatedAt: "2022-01-01T00:00:00Z"
			},
			attachmentAssets: [],
			phases: []
		}
	}
}), Wt = n({
	route: ({ id: e }) => `/quote-templates/${e}/archive`,
	method: "POST",
	invalidateQueries: [j],
	mocking: {
		match: /\/api\/quote-templates\/(.+)\/archive$/,
		mock: {
			template: {
				id: "1",
				title: "Test Quote Template",
				currency: "USD",
				presentation: [],
				dealType: "NEW_BUSINESS",
				createdAt: "2022-01-01T00:00:00Z",
				createdBy: "1",
				updatedAt: "2022-01-01T00:00:00Z"
			},
			attachmentAssets: [],
			phases: []
		}
	}
}), M = "quotes", Gt = "quoteBulkDownloadZip", N = "quotes.published", P = [
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-06-10",
		structure: {
			pricingType: "ONE_TIME",
			price: "3500.00"
		},
		billingFrequency: "ONE_TIME",
		billingType: "IN_ARREARS",
		integrationIds: [],
		customMetricParameters: []
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-03-12",
		structure: {
			pricingType: "FIXED",
			price: "3500.00"
		},
		billingFrequency: "MONTHLY",
		billingType: "IN_ARREARS",
		integrationIds: [],
		customMetricParameters: []
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-01-30",
		structure: {
			pricingType: "LINEAR",
			pricePerUnit: "3500.00",
			usageMetricId: "01956fe4-558a-465d-8e30-b948a8c4b132",
			isPricePercentage: !1
		},
		billingFrequency: "MONTHLY",
		billingType: "IN_ARREARS",
		integrationIds: [],
		customMetricParameters: []
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-04-25",
		structure: {
			tiers: [{
				fee: "50.00",
				price: "25.00111",
				upperBound: "10000.01078",
				isPricePercentage: !1
			}, {
				fee: "0.00",
				price: "5.00",
				isPricePercentage: !1
			}],
			pricingType: "GRADUATED",
			usageMetricId: "018c59d2-dc31-7e4e-9202-ee1c239b31ce",
			usageCalculationMode: "BILLING_PERIOD"
		},
		billingFrequency: "MONTHLY",
		billingType: "IN_ARREARS",
		integrationIds: [{
			service: "Xero",
			id: "123"
		}],
		customMetricParameters: []
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-02-15",
		structure: {
			tiers: [{
				fee: "50.00",
				price: "25.00111",
				upperBound: "10000.01078",
				isPricePercentage: !1
			}, {
				fee: "0.00",
				price: "5.00",
				isPricePercentage: !1
			}],
			pricingType: "VOLUME",
			usageMetricId: "018c59d2-dc31-7e4e-9202-ee1c239b31ce"
		},
		billingFrequency: "MONTHLY",
		billingType: "IN_ADVANCE",
		integrationIds: [],
		customMetricParameters: []
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2023-12-20",
		structure: {
			tiers: [{
				fee: "50.00",
				price: "25.00111",
				upperBound: "10000.01078",
				isPricePercentage: !0,
				maxPrice: "10",
				minPrice: "1"
			}, {
				fee: "0.00",
				price: "5.00",
				isPricePercentage: !0,
				maxPrice: "10",
				minPrice: "1"
			}],
			pricingType: "VOLUME",
			usageMetricId: "018c59d2-dc31-7e4e-9202-ee1c239b31ce"
		},
		billingFrequency: "MONTHLY",
		billingType: "IN_ARREARS",
		integrationIds: [],
		customMetricParameters: []
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-02-17",
		structure: {
			pricePerPackage: "10",
			packageSize: "20",
			pricingType: "PACKAGE",
			usageMetricId: "018c59d2-dc31-7e4e-9202-ee1c239b31ce"
		},
		billingFrequency: "YEARLY",
		billingType: "IN_ARREARS",
		integrationIds: [],
		customMetricParameters: [{
			parameterId: "079f93a2-e4d8-4729-a32a-de2511a7d1d1",
			value: "10"
		}]
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-04-22",
		structure: {
			pricingType: "SEAT_BASED",
			seatMetricId: "2f97a232-d389-480b-b7ce-0610e6116ceb",
			pricePerSeat: "3500.00",
			prorationStrategy: "USE_MAXIMUM",
			contractedMinimumSeats: 10,
			tiers: [],
			prorateFlatFees: !1
		},
		billingFrequency: "MONTHLY",
		billingType: "IN_ARREARS",
		integrationIds: [],
		customMetricParameters: []
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-05-01",
		structure: {
			pricingType: "SEAT_BASED",
			seatMetricId: "2f97a232-d389-480b-b7ce-0610e6116ceb",
			pricePerSeat: "3500.00",
			prorationStrategy: "USE_MAXIMUM",
			contractedMinimumSeats: 10,
			overagesBillingFrequency: "MONTHLY",
			tiers: [],
			prorateFlatFees: !1
		},
		billingFrequency: "YEARLY",
		billingType: "IN_ARREARS",
		integrationIds: [],
		customMetricParameters: []
	},
	{
		id: "018fbed7-b1a6-7fff-8954-f913c357b5b9",
		productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
		name: "More dolla",
		createdAt: "2024-06-10",
		structure: {
			pricingType: "SEAT_BASED",
			seatMetricId: "2f97a232-d389-480b-b7ce-0610e6116ceb",
			pricePerSeat: "0",
			prorationStrategy: "USE_MAXIMUM",
			contractedMinimumSeats: 10,
			tiers: [{
				price: "25.00111",
				upperBound: "10000.01078"
			}, {
				price: "5.00",
				fee: "10.00"
			}],
			prorateFlatFees: !1
		},
		billingFrequency: "MONTHLY",
		billingType: "IN_ARREARS",
		integrationIds: [],
		customMetricParameters: []
	}
], Kt = {
	id: "018fbe90-cefa-79e5-b17a-a0a5525b38bc",
	createdBy: "46204534-85ba-4187-96d9-9cc5d7175b31",
	quoteNumber: "Q00130",
	title: "Foo",
	currency: "USD",
	pdfStatus: "NOT_YET_REQUESTED",
	presentation: [{
		config: { phases: [{
			id: "new-uuid",
			name: "Phase 1",
			dates: {
				absolute: {
					end: "",
					start: ""
				},
				duration: { years: 1 }
			},
			prices: P,
			minimums: [{
				id: "new-minimum::944be936-ea22-4f37-8c6e-71eb1f682387",
				name: "",
				scope: {
					target: "allUsage",
					priceIds: []
				},
				value: "15.00"
			}],
			discounts: []
		}, {
			id: "new-phase::01723118-789f-435c-b398-619ac3982928",
			dates: {
				absolute: {
					end: "",
					start: ""
				},
				duration: { years: 1 }
			},
			prices: [{
				id: "new-price::60181225-95a0-4062-b89b-657de93404d3",
				name: "More dolla",
				productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
				structure: {
					price: "3500.00",
					pricingType: "FIXED"
				},
				parameters: [],
				billingType: "IN_ARREARS",
				externalIds: [],
				billingFrequency: "MONTHLY"
			}],
			minimums: [],
			discounts: [{
				id: "new-discount::25b1e237-136e-4c35-8cc0-53ea89a7d192",
				amount: 5,
				message: "New discount",
				priceIds: ["new-price::60181225-95a0-4062-b89b-657de93404d3"],
				applyToAllPrices: !1,
				discountCalculationType: "PERCENTAGE"
			}]
		}] },
		version: 1,
		blockType: "phases"
	}, {
		config: { text: [] },
		version: 1,
		blockType: "paragraph"
	}],
	customerId: "customer-123",
	publishedAt: "2024-05-28T10:55:57.776435Z",
	expiresAt: "2024-06-27",
	isExpired: !1,
	status: "PUBLISHED",
	dealType: "NEW_BUSINESS",
	createdAt: "2024-05-28T09:38:32.307766Z",
	updatedAt: "2024-05-28T10:55:57.776435Z",
	readyToSignAt: "2024-05-28T10:55:57.776435Z",
	expiryDays: 30,
	merchantBranding: {
		logoUrl: "https://backend-production-librarybucket-1izigk5lryla9.s3.amazonaws.com/48bc5c87-69dd-4d3a-b977-8a3ce36efefd/1695221702164_download.jpeg",
		legalCompanyName: "Kai Test",
		primaryColour: "#2A9EDB",
		address: {
			line1: "Foo",
			line2: "Bar",
			town: "Hixon't",
			postcode: "ST1 1AA",
			country: "GB"
		},
		email: "foo@bar.com"
	},
	phases: [{
		id: "018fbed7-b1aa-7baa-ade6-0f3faaa4982d",
		createdAt: "2024-05-28T10:55:57.866154Z",
		name: "Phase 1",
		duration: {
			months: 0,
			years: 1
		},
		prices: P,
		discounts: [],
		minimums: [{
			id: "018fbed7-b1aa-7baa-ade7-54f102f362cc",
			amount: "15",
			restrictToPrices: [],
			createdAt: "2024-05-28T10:55:57.866181Z",
			updatedAt: "2024-05-28T10:55:57.866181Z"
		}]
	}, {
		id: "018fbed7-b1cf-719c-b46d-04554289888e",
		duration: {
			months: 0,
			years: 1
		},
		prices: [{
			id: "018fbed7-b1cb-782b-b331-eeb71fe1cea3",
			productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
			name: "More dolla",
			createdAt: "2024-04-05",
			structure: {
				pricingType: "FIXED",
				price: "3500.00"
			},
			billingFrequency: "MONTHLY",
			billingType: "IN_ARREARS",
			integrationIds: [],
			customMetricParameters: []
		}],
		discounts: [{
			id: "018fbed7-b1cf-719c-b46e-7deb87e939e6",
			restrictToPrices: ["018fbed7-b1cb-782b-b331-eeb71fe1cea3"],
			amount: "5",
			discountCalculationType: "PERCENTAGE",
			message: "New discount",
			seatDiscountType: "ALL_SEATS"
		}],
		minimums: [{
			id: "13295b5e-d609-4e49-8ed5-38301cad9c6e",
			restrictToPrices: ["018fbed7-b1cb-782b-b331-eeb71fe1cea3"],
			amount: "5"
		}]
	}],
	contacts: [{
		contactId: "contact-1",
		name: "John",
		email: "john@example.com",
		signedAt: void 0
	}, {
		contactId: "contact-2",
		name: "Mary",
		email: "mary@example.com",
		signedAt: "2024-05-28T10:55:57.866181Z"
	}],
	counterSigners: [{
		id: "counter-signer-1",
		name: "Adam",
		email: "adam@example-pet-store.com",
		signedAt: void 0
	}, {
		id: "counter-signer-2",
		name: "Becky",
		email: "Becky@example-pet-store.com",
		signedAt: "2024-05-28T10:55:57.866181Z"
	}],
	isSignaturesEnabled: !0,
	attachmentAssets: [{
		id: "assetId",
		type: "IMAGE",
		url: "url",
		fileName: "file",
		fileSizeBytes: 10,
		format: "PDF",
		createdBy: "upload-user-1",
		createdAt: "2025-03-11T00:00:00.000Z"
	}]
}, qt = t({
	route: ({ id: e }) => `/quotes/${e}`,
	queryKey: [M],
	mocking: {
		match: /\/api\/quotes\/([^/]+)$/,
		mock: Kt
	}
}), Jt = n({
	route: ({ id: e }) => `/quotes/from-template/${e}`,
	method: "POST",
	invalidateQueries: [M],
	mocking: {
		match: /\/api\/quotes\/from-template\/(.+)$/,
		mock: Kt
	}
}), Yt = n({
	route: () => "/quote-templates",
	method: "POST",
	invalidateQueries: [j],
	body: ({ quoteId: e } = {}) => JSON.stringify(e ? { quoteId: e } : {}),
	mocking: {
		match: /\/api\/quote-templates$/,
		mock: {
			template: {
				id: "1",
				title: "Test Quote Template",
				currency: "USD",
				presentation: [],
				dealType: "NEW_BUSINESS",
				createdAt: "2022-01-01T00:00:00Z",
				createdBy: "1",
				updatedAt: "2022-01-01T00:00:00Z"
			},
			attachmentAssets: [],
			phases: []
		}
	}
}), Xt = n({
	route: ({ id: e }) => `/quote-templates/from-quote/${e}`,
	method: "POST",
	invalidateQueries: [M, j],
	mocking: {
		match: /\/api\/quote-templates\/from-quote\/(.+)$/,
		mock: {
			template: {
				id: "1",
				title: "Test Quote Template",
				currency: "USD",
				presentation: [],
				dealType: "NEW_BUSINESS",
				createdAt: "2022-01-01T00:00:00Z",
				createdBy: "1",
				updatedAt: "2022-01-01T00:00:00Z"
			},
			attachmentAssets: [],
			phases: []
		}
	}
}), Zt = n({
	route: ({ id: e }) => `/quote-templates/${e}/duplicate`,
	method: "POST",
	invalidateQueries: [j],
	mocking: {
		match: /\/api\/quote-templates\/(.+)\/duplicate$/,
		mock: {
			template: {
				id: "1",
				title: "Test Quote Template",
				currency: "USD",
				presentation: [],
				dealType: "NEW_BUSINESS",
				createdAt: "2022-01-01T00:00:00Z",
				createdBy: "1",
				updatedAt: "2022-01-01T00:00:00Z"
			},
			attachmentAssets: [],
			phases: []
		}
	}
}), Qt = {
	getQuoteTemplate: Ut,
	getListQuoteTemplates: Ht,
	postArchiveQuoteTemplate: Wt,
	postCreateQuoteFromTemplate: Jt,
	postCreateQuoteTemplate: Yt,
	putUpdateQuoteTemplate: n({
		route: ({ id: e }) => `/quote-templates/${e}`,
		method: "PUT",
		invalidateQueries: [j],
		body: ({ body: e }) => JSON.stringify({
			template: e.template,
			phases: e.phases,
			attachmentAssetIds: e.attachmentAssetIds
		}),
		mocking: {
			match: /\/api\/quote-templates\/(.+)$/,
			mock: {
				template: {
					id: "1",
					title: "Test Quote Template",
					currency: "USD",
					presentation: [],
					dealType: "NEW_BUSINESS",
					createdAt: "2022-01-01T00:00:00Z",
					createdBy: "1",
					updatedAt: "2022-01-01T00:00:00Z"
				},
				phases: [],
				attachmentAssets: []
			}
		}
	}),
	postCreateQuoteTemplateFromQuote: Xt,
	postDuplicateQuoteTemplate: Zt
}, F = "usageEvents", $t = "usageEventProperties", en = "usageEventTypes", tn = {
	getUniqueUsageEventProperties: t({
		route: (e) => `/unique-usage-event-properties${s(e)}`,
		queryKey: [$t],
		mocking: {
			match: /\/api\/unique-usage-event-properties(\?(.*))?$/,
			mock: { items: ["transactions"] }
		}
	}),
	getUsageEvents: t({
		route: (e) => {
			let { customerAlias: t, ...n } = e || {};
			if (t) {
				let e = t.split(",").map((e) => `customerAlias=${e}`).join("&"), r = s(n);
				return r ? `/usage-events${r}&${e}` : `/usage-events?${e}`;
			}
			return `/usage-events${s(e)}`;
		},
		queryKey: [F],
		mocking: {
			match: /\/api\/usage-events(\?(.*))?$/,
			mock: {
				items: [{
					id: "01849e38-bbb0-7fab-86eb-62865adf75c7",
					customerEventId: "eventid-33bb8cbb-430f-43d1-b26a-29a9e534e598",
					customerAlias: "7d9249ce-aa44-45fe-99dd-2847dd4b3112",
					eventType: "message_sent",
					eventTimestamp: "2022-06-28T16:47:00Z",
					eventProperties: {
						type: "abcd",
						length: 1
					},
					sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d"
				}],
				pagination: {
					after: "",
					before: "",
					totalResultSize: 1
				}
			}
		}
	}),
	getUniqueUsageEventTypes: t({
		route: (e) => `/unique-usage-event-types${s(e)}`,
		queryKey: [en],
		mocking: {
			match: /\/api\/unique-usage-event-types(\?(.*))?$/,
			mock: { items: ["transactions"] }
		}
	}),
	getUsageEvent: t({
		route: ({ id: e }) => `/usage-events/${e}`,
		queryKey: [F],
		mocking: {
			match: /\/api\/usage-events\/(.*)$/,
			mock: {
				id: "0184421a-8202-70ea-a729-30308a40bbf7",
				customerEventId: "event-id-H4twuTWpYx1rkd8OMTki2hTUcZ",
				customerAlias: "customer-id-2H4u5BBwBWsS5V2sroRFqJfTXpW",
				eventType: "message-sent",
				sequenceAccountId: "0184421e-a9cc-711b-af93-bf0511d4d833",
				eventTimestamp: "2022-10-01T00:00:00Z",
				eventProperties: {}
			}
		}
	}),
	postUsageEvent: n({
		route: () => "/usage-events",
		invalidateQueries: [F],
		method: "POST",
		body: (e) => JSON.stringify(e),
		mocking: {
			match: /\/api\/usage-events$/,
			mock: {
				id: "0184421a-8202-70ea-a729-30308a40bbf7",
				customerEventId: "event-id-H4twuTWpYx1rkd8OMTki2hTUcZ",
				customerAlias: "customer-id-2H4u5BBwBWsS5V2sroRFqJfTXpW",
				eventType: "message-sent",
				sequenceAccountId: "0184421e-a9cc-711b-af93-bf0511d4d833",
				eventTimestamp: "2022-10-01T00:00:00Z",
				eventProperties: {
					length: 500,
					type: "text_message"
				}
			}
		}
	})
}, I = "usageMetrics", nn = {
	getUsageMetric: t({
		route: ({ id: e }) => `/usage-metrics/${e}`,
		queryKey: [I],
		mocking: {
			match: /\/api\/usage-metrics\/([^\/]+)$/,
			mock: {
				id: "01849e38-bbb0-7fab-86eb-62865adf75c7",
				name: "name",
				description: "desc",
				metricType: "SIMPLE",
				eventType: "event",
				aggregationType: "SUM",
				createdAt: "2022-06-28T16:47:00Z",
				propertyFilters: {},
				caseSensitive: !1,
				propertiesToNegate: [],
				parameters: [],
				sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d",
				aggregationProperty: void 0,
				groupingProperty: void 0,
				unit: void 0
			}
		}
	}),
	getUsageMetrics: t({
		route: (e) => `/usage-metrics${s(e)}`,
		queryKey: [I],
		mocking: {
			match: /\/api\/usage-metrics(\?(.*))?$/,
			mock: {
				items: [{
					id: "01849e38-bbb0-7fab-86eb-62865adf75c7",
					name: "name",
					description: "desc",
					metricType: "SIMPLE",
					eventType: "event",
					aggregationType: "SUM",
					createdAt: "2022-06-28T16:47:00Z",
					propertyFilters: {},
					caseSensitive: !1,
					propertiesToNegate: [],
					parameters: [],
					sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d",
					aggregationProperty: void 0,
					groupingProperty: void 0,
					unit: void 0
				}],
				pagination: {
					after: "",
					before: "",
					totalResultSize: 1
				}
			}
		}
	}),
	postUsageMetric: n({
		route: () => "/usage-metrics",
		method: "POST",
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [
			I,
			en,
			$t
		],
		mocking: {
			match: /\/api\/usage-metrics$/,
			mock: {
				name: "API CALL PART 3",
				metricType: "SIMPLE",
				eventType: "aerial_photo_api_call",
				aggregationType: "SUM",
				aggregationProperty: "123",
				propertyFilters: {},
				id: "test-bf64-76ab-9e8b-27b2870cb66d",
				sequenceAccountId: "test-sequence-account-id",
				parameters: [],
				propertiesToNegate: [],
				createdAt: "2021-09-01T00:00:00.000Z",
				caseSensitive: !1
			}
		}
	}),
	putUsageMetric: n({
		route: ({ id: e }) => `/usage-metrics/${e}`,
		method: "PUT",
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [I],
		mocking: {
			match: /\/api\/usage-metrics\/(.+)$/,
			mock: {
				id: "test-bf64-76ab-9e8b-27b2870cb66d",
				sequenceAccountId: "test-sequence-account-id",
				parameters: [],
				propertiesToNegate: [],
				createdAt: "2021-09-01T00:00:00.000Z",
				caseSensitive: !1,
				name: "API CALL PART 3",
				metricType: "SIMPLE",
				eventType: "aerial_photo_api_call",
				aggregationType: "SUM",
				aggregationProperty: "123",
				propertyFilters: {}
			}
		}
	}),
	getCalculateUsageMetric: t({
		route: ({ id: e, customParameters: t, ...n }) => `/usage-metrics/${e}/calculate${s({
			...n,
			customerAliases: n.customerAliases.join(","),
			customParameters: t ? JSON.stringify(t) : void 0
		})}`,
		queryKey: ["usageMetricsCalculation"],
		mocking: {
			match: /\/api\/usage-metrics\/(.+)\/calculate(\?(.*))?$/,
			mock: {
				name: "total_messages_sent",
				metricType: "GROUPED",
				eventType: "message_sent",
				aggregationType: "SUM",
				eventCount: 5,
				value: 150.035,
				unit: "bytes",
				minEventId: "0183d0f1-6b5a-74d4-9129-1f4b90191666",
				maxEventId: "0183ea03-aca0-7019-b80d-6aacce344e92"
			}
		}
	})
}, rn = {
	getAliasesForCustomer: t({
		route: ({ customerId: e }) => `/customers/${e}/aliases`,
		queryKey: [i],
		mocking: {
			match: /\/api\/customers\/[^\/]+\/aliases$/,
			mock: { items: [{
				id: "0185a140-194a-7e9d-9fae-6a034fd4a725",
				sequenceAccountId: "cd243b67-7d8c-42ee-b19f-b4e41f584415",
				customerId: "0185a142-54ff-7ce5-846a-fc188432da6e",
				value: "customer-alias-123",
				createdAt: "2022-10-01T00:00:00Z"
			}] }
		}
	}),
	getCustomer: t({
		route: (e) => `/customers/${e.id}`,
		queryKey: [a],
		persist: !0,
		mocking: {
			match: /\/api\/customers\/[^\/]+$/,
			mock: {
				contacts: [{
					id: "contact-1",
					name: "John Doe",
					email: "foo@bar.com",
					purposes: ["BILLING"],
					notificationSubscriptions: ["BILLING"],
					createdAt: "string",
					updatedAt: "string"
				}],
				createdAt: "string",
				integrationIds: [{
					service: "Xero",
					id: "xero-customer-1",
					isPending: !1
				}],
				organizations: [{
					id: "org-1",
					owner: {
						id: "owner-1",
						name: "Jane Doe"
					},
					members: [{
						id: "member-1",
						name: "John Doe"
					}]
				}],
				id: "customer-1",
				legalName: "string",
				addresses: [{
					purposes: ["BILLING"],
					address: {
						line1: "string",
						town: "string",
						state: "NY",
						postcode: "string",
						country: "US"
					}
				}],
				domain: "example.com",
				url: "string",
				label: "string",
				taxStatus: "TAXED"
			}
		}
	}),
	getCustomerAliases: t({
		route: (e) => `/customer-aliases${s(e)}`,
		queryKey: [i],
		mocking: {
			match: /\/api\/customer-aliases(\?(.*))?$/,
			mock: {
				items: [{
					id: "01849e70-0a0f-72ca-ba07-5557dd734d43",
					sequenceAccountId: "ec1479a2-6ba1-421f-a7de-0853a20d17a1",
					customerId: "01849e70-703e-705a-b59a-d3fd575587e0",
					value: "external-customer-alias-123",
					createdAt: "2022-10-01T00:00:00Z",
					deletedAt: "2022-10-01T00:00:00Z",
					label: "CRM ID",
					archivedAt: "2022-10-01T00:00:00Z"
				}],
				pagination: {
					after: "",
					before: "",
					totalResultSize: 1
				}
			}
		}
	}),
	getCustomers: t({
		route: (e) => `/customers${s(e)}`,
		queryKey: [a],
		persist: !0,
		mocking: {
			match: /\/api\/customers(\?(.*))?$/,
			mock: {
				items: [{
					id: "test-customer-1",
					legalName: "Fintech Payment Processing",
					addresses: [{
						purposes: ["BILLING"],
						address: {
							line1: "7500 Bluewater Rd NW",
							town: "Albuquerque",
							state: "NY",
							postcode: "87121",
							country: "US"
						}
					}],
					url: "https://example.com/",
					label: "Example customer",
					integrationIds: [{
						service: "Xero",
						id: "2aaff66f-ef30-4599-b192-c168fd4cd226",
						isPending: !1
					}],
					taxStatus: "TAXED",
					organizations: [{
						id: "c0dc4e79-ec52-4811-8cf5-addb2527915c",
						owner: {
							id: "50af5191-05a3-42a5-802a-6b59091157af",
							name: "FinTech Solutions Inc."
						},
						members: [{
							id: "test-customer-1",
							name: "Fintech Payment Processing"
						}, {
							id: "50af5191-05a3-42a5-802a-6b59091157af",
							name: "Fintech Lending Services"
						}]
					}],
					createdAt: "2021-01-02T10:55:00Z"
				}],
				pagination: {
					after: "",
					before: "",
					totalResultSize: 1
				}
			}
		}
	}),
	getCustomersCsvDownload: t({
		route: (e) => {
			let t = Object.entries(e?.customPropertyFilters ?? {}).reduce((e, [t, n]) => !t || !n ? e : {
				...e,
				[`customProperties.${t}`]: n
			}, {});
			return `/customers/customers-csv${s({
				legalName: e?.legalName,
				email: e?.email,
				alias: e?.alias,
				label: e?.label,
				billingStatus: e?.billingStatus,
				includeArchived: e?.includeArchived,
				includeCustomProperties: e?.includeCustomProperties?.join(","),
				...t
			})}`;
		},
		config: { responseTransform: (e) => e.blob() },
		queryKey: [te],
		mocking: {
			match: /\/api\/customers\/customers-csv(\?(.*))?$/,
			mock: new Blob([""], { type: "text/csv" })
		}
	}),
	getCustomerCustomPropertyKeys: t({
		route: () => "/customer-custom-property-keys",
		queryKey: [a, r],
		mocking: {
			match: /\/api\/customer-custom-property-keys$/,
			mock: { items: ["region", "tier"] }
		}
	}),
	postCustomer: n({
		route: () => "/customers",
		method: "POST",
		body: ({ body: e }) => JSON.stringify({
			...o(e, [
				"name",
				"legalName",
				"email",
				"contactName"
			]),
			contacts: o(e.contacts, ["name", "email"]),
			addresses: o(e.addresses, ["address"])
		}),
		invalidateQueries: [a, r],
		mocking: {
			match: /\/api\/customers$/,
			mock: {
				legalName: "Company Name",
				organizations: [],
				id: "customer-2",
				integrationIds: [],
				createdAt: "2021-01-01T00:00:00Z",
				addresses: [{
					purposes: ["BILLING"],
					address: {
						line1: "123 Fake St",
						town: "Sydney",
						postcode: "2000",
						country: "AU"
					}
				}],
				taxStatus: "TAXED",
				contacts: [{
					id: "123",
					createdAt: "2021-01-01T00:00:00Z",
					updatedAt: "2021-01-01T00:00:00Z",
					name: "John Doe",
					email: "foo@bar.com",
					purposes: ["BILLING"],
					notificationSubscriptions: ["BILLING"]
				}, {
					id: "456",
					createdAt: "2021-01-01T00:00:00Z",
					updatedAt: "2021-01-01T00:00:00Z",
					name: "Jane Doe",
					email: "bar@foo.com",
					purposes: [],
					notificationSubscriptions: []
				}]
			}
		}
	}),
	putCustomer: n({
		route: ({ id: e }) => `/customers/${e}`,
		method: "PUT",
		body: ({ body: e }) => {
			let { address: t, ...n } = e;
			return JSON.stringify({
				...o(n, ["legalName"]),
				contacts: o(n.contacts, ["name", "email"]),
				addresses: o(n.addresses, ["address"])
			});
		},
		invalidateQueries: [a, r],
		mocking: {
			match: /\/api\/customers\/(.+)$/,
			mock: {
				legalName: "Company Name",
				addresses: [{
					purposes: ["BILLING"],
					address: {
						line1: "123 Fake St",
						town: "Sydney",
						postcode: "2000",
						country: "AU"
					}
				}],
				taxStatus: "TAXED",
				contacts: [{
					id: "123",
					name: "John Doe",
					email: "foo@bar.com",
					purposes: ["BILLING"],
					notificationSubscriptions: ["BILLING"],
					createdAt: "2021-01-01T00:00:00Z",
					updatedAt: "2021-01-01T00:00:00Z"
				}],
				id: "customer-2",
				integrationIds: [],
				createdAt: "2021-01-01T00:00:00Z",
				organizations: []
			}
		}
	}),
	postCustomerAlias: n({
		route: () => "/customer-aliases",
		method: "POST",
		body: ({ customerId: e, value: t, label: n }) => JSON.stringify({
			customerId: e,
			value: t,
			label: n
		}),
		invalidateQueries: [i, a],
		mocking: {
			match: /\/api\/customer-aliases$/,
			mock: {
				id: "01849e70-0a0f-72ca-ba07-5557dd734d43",
				sequenceAccountId: "ec1479a2-6ba1-421f-a7de-0853a20d17a1",
				customerId: "01849e70-703e-705a-b59a-d3fd575587e0",
				value: "external-customer-alias-123",
				createdAt: "2022-10-01T00:00:00Z",
				deletedAt: "2022-10-01T00:00:00Z",
				label: "CRM ID",
				archivedAt: "2022-10-01T00:00:00Z"
			}
		}
	}),
	getCustomerByAlias: t({
		route: ({ alias: e }) => `/customers/by-alias/${e}`,
		queryKey: [a],
		persist: !0,
		mocking: {
			match: /\/api\/customers\/by-alias\/[^\/]+$/,
			mock: {
				id: "e309e948-088e-4d77-b654-cd85498f1555",
				createdAt: "2022-06-28T16:47:00Z",
				legalName: "John Doe",
				contactName: "John Doe",
				addresses: [{
					purposes: ["BILLING"],
					address: {
						line1: "Flat 1",
						town: "New York",
						state: "NY",
						postcode: "AB1 2EF",
						country: "US"
					}
				}],
				email: "john@example.com",
				telephone: "02010001000",
				url: "https://example.com/",
				label: "Example customer",
				integrationIds: [{
					service: "Xero",
					id: "ID",
					lastSynced: "2022-06-28T16:47:00Z",
					isPending: !1
				}, {
					service: "Stripe",
					id: "cus_OCtCxqQDgu1uX9",
					lastSynced: "2022-06-28T16:47:00Z",
					isPending: !1
				}],
				archivedAt: "2022-06-28T16:47:00Z",
				billingEmails: ["exampleCorpInvoices@example.com"],
				taxStatus: "TAXED"
			}
		}
	}),
	postArchiveCustomer: n({
		route: ({ id: e }) => `/customers/${e}/archive`,
		invalidateQueries: [a, i],
		method: "POST",
		mocking: {
			match: /\/api\/customers\/(.+)\/archive$/,
			mock: {
				id: "e309e948-088e-4d77-b654-cd85498f1555",
				createdAt: "2021-01-02T10:55:00Z",
				organizations: [{
					id: "c0dc4e79-ec52-4811-8cf5-addb2527915c",
					owner: {
						id: "50af5191-05a3-42a5-802a-6b59091157af",
						name: "FinTech Solutions Inc."
					},
					members: [{
						id: "e309e948-088e-4d77-b654-cd85498f1555",
						name: "Fintech Payment Processing"
					}, {
						id: "50af5191-05a3-42a5-802a-6b59091157af",
						name: "Fintech Lending Services"
					}]
				}],
				legalName: "Fintech Payment Processing",
				addresses: [{
					purposes: ["BILLING"],
					address: {
						line1: "7500 Bluewater Rd NW",
						town: "Albuquerque",
						state: "NY",
						postcode: "87121",
						country: "US"
					}
				}],
				url: "https://example.com/",
				domain: "example.com",
				label: "Example customer",
				integrationIds: [{
					service: "Xero",
					id: "2aaff66f-ef30-4599-b192-c168fd4cd226",
					lastSynced: "2024-03-28T16:47:00Z",
					isPending: !1
				}, {
					service: "Stripe",
					id: "cus_OCtCxqQDgu1uX9",
					lastSynced: "2024-03-28T16:47:00Z",
					isPending: !1
				}],
				taxStatus: "TAXED",
				contacts: [{
					id: "9a1e38a9-4dc9-776f-f974-4e7ee9f4d6cc",
					name: "John Smith",
					email: "john.smith@example.com",
					purposes: [],
					notificationSubscriptions: [],
					createdAt: "2022-06-28T16:47:00Z",
					updatedAt: "2022-06-28T16:47:00Z",
					archivedAt: "2023-06-28T16:47:00Z"
				}]
			}
		}
	})
}, an = "assets", L = {
	postAssets: n({
		route: () => "/assets",
		method: "POST",
		body: ({ formData: e }) => (ne(e.has("file"), "formData.file is required"), e),
		requestOptions: { headers: { "Content-Type": null } },
		invalidateQueries: [an],
		mocking: {
			match: /\/api\/assets$/,
			mock: {
				id: "123",
				type: "IMAGE",
				url: "https://example.com",
				fileName: "foo.jpg",
				fileSizeBytes: 1e4,
				format: "PDF",
				createdBy: "upload-user-1",
				createdAt: "2025-03-11T00:00:00.000Z"
			}
		}
	}),
	getAsset: t({
		route: ({ id: e }) => `/assets/${e}`,
		queryKey: [an],
		mocking: {
			match: /\/api\/assets\/([^\/]+?)$/,
			mock: {
				id: "asset-1",
				type: "DOCUMENT",
				format: "PDF",
				url: "https://example.com/document.pdf",
				fileName: "document.pdf",
				fileSizeBytes: 1234,
				createdAt: "2025-03-11T00:00:00.000Z",
				createdBy: "user-1"
			}
		}
	})
}, on = {
	getQuickbooksAccountPreferences: t({
		route: () => "/quickbooks/account-preferences",
		queryKey: ["quickbooks", "account-preferences"],
		mocking: {
			match: /\/api\/quickbooks\/account-preferences$/,
			mock: {
				multiCurrencyEnabled: !0,
				homeCurrency: "CAD"
			}
		}
	}),
	postSyncQuickbooksAccounts: n({
		route: () => "/quickbooks/accounts/pull",
		method: "POST",
		invalidateQueries: ["quickbooksAccounts"],
		mocking: {
			match: /\/api\/quickbooks\/accounts\/pull$/,
			mock: void 0
		}
	})
}, R = "users", sn = /* @__PURE__ */ e({ deleteUser: () => cn }), cn = n({
	route: ({ id: e }) => `/users/${e}`,
	method: "DELETE",
	invalidateQueries: [R],
	mocking: {
		match: /\/users\/[^\/]+$/,
		mock: {
			id: "user-1",
			email: "foo@bar.com",
			sequenceAccountIds: ["foo"],
			state: "deleted"
		}
	}
}), ln = /* @__PURE__ */ e({ getUser: () => un }), un = t({
	route: ({ id: e }) => `/users/${e}`,
	method: "GET",
	queryKey: [R],
	mocking: {
		match: /\/users\/[^\/]+$/,
		mock: {
			id: "user-1",
			email: "foo@bar.com",
			sequenceAccountIds: ["foo"],
			state: "active"
		}
	}
}), dn = /* @__PURE__ */ e({ getUsers: () => fn }), fn = t({
	route: ({ limit: e = 100, ...t } = {}) => `/users${s({
		limit: e,
		...t
	})}`,
	method: "GET",
	queryKey: [R],
	mocking: {
		match: /\/api\/users(\?(.*))?$/,
		mock: {
			items: [{
				id: "user-1",
				email: "foo@bar.com",
				sequenceAccountIds: ["foo"],
				state: "active"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), pn = /* @__PURE__ */ e({}), mn = {
	getUser: un,
	getUsers: fn,
	deleteUser: cn
}, z = "oauthClients", hn = /* @__PURE__ */ e({ deleteOAuthClient: () => gn }), gn = n({
	route: ({ id: e }) => `/oauth-clients/${e}`,
	method: "DELETE",
	invalidateQueries: [z],
	mocking: {
		match: /\/api\/oauth-clients\/[^\/]+$/,
		mock: {
			id: "client-1",
			sequenceAccountId: "foo",
			name: "client",
			scopes: ["foo"],
			pinnedApiVersion: "v20240730"
		}
	}
}), _n = /* @__PURE__ */ e({ getOAuthClients: () => vn }), vn = t({
	route: ({ limit: e = 100, ...t }) => `/oauth-clients${s({
		limit: e,
		...t
	})}`,
	queryKey: [z],
	mocking: {
		match: /\/api\/oauth-clients(\?(.*))?$/,
		mock: {
			items: [{
				id: "7b1f28b9-a4ad-450b-a0ea-fd647d5109b2",
				sequenceAccountId: "c9e249d8-5ac9-49af-b9a3-0da9f0946c3d",
				name: "Client",
				scopes: ["product"],
				pinnedApiVersion: "2024-01-01"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), yn = /* @__PURE__ */ e({ postOAuthClient: () => bn }), bn = n({
	route: () => "/oauth-clients",
	body: (e) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [z],
	mocking: {
		match: /\/api\/oauth-clients$/,
		status: 201,
		mock: {
			id: "6267e4e5-688e-4eda-92d1-45a4031fe5b2",
			name: "seqhq-7e330949-a175-496a-a060-27821656ce34",
			secret: "somerandomsecret"
		}
	}
}), xn = /* @__PURE__ */ e({ postSession: () => Sn }), Sn = n({
	route: () => "/auth/session",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [],
	mocking: {
		match: /\/api\/auth\/session$/,
		mock: { session: {
			requestId: "request-id-1",
			memberAuthenticated: !0,
			member: {
				id: "member-id-1",
				name: "John Doe",
				email: "",
				emailAddressVerified: !0,
				organisationId: "organisation-id-1"
			},
			memberSession: {
				memberSessionId: "session-id-1",
				expiresAt: "2022-10-01T00:00:00Z",
				startedAt: "2022-10-01T00:00:00Z",
				sequenceAccountId: "account-id-1",
				sequenceUserId: "user-id-1"
			},
			sessionJwt: ""
		} }
	}
}), Cn = {
	getOAuthClients: vn,
	deleteOAuthClient: gn,
	postOAuthClient: bn,
	postSession: Sn
}, wn = "merchant", Tn = /* @__PURE__ */ e({ getMerchantForSequenceAccount: () => En }), En = t({
	route: () => "/merchant-for-sequence-account",
	queryKey: [wn],
	mocking: {
		match: /api\/merchant-for-sequence-account$/,
		mock: {
			id: "8252c275-80ce-4845-abe7-027f5b2daa8c",
			sequenceAccountId: "af9b5988-1d7b-45f6-a188-326df5e59b24",
			invoiceNumberPrefix: "SEQ",
			creditNoteNumberPrefix: "SCN",
			legalCompanyName: "The Merchant",
			address: {
				line1: "Flat 1",
				line2: "123 Fake Street",
				town: "New York",
				state: "NY",
				postcode: "AB1 2EF",
				country: "US"
			},
			phoneNumber: "0800001066",
			email: "donald@example.com",
			defaultDueDateDays: 30,
			lastInvoiceNumber: 1,
			lastCreditNoteNumber: 0,
			bankAccountDetails: [{
				key: "GBP",
				value: {
					type: "UK_BANK_ACCOUNT",
					ukBankAccount: {
						sortCode: "123456",
						accountNumber: "12345678"
					}
				}
			}, {
				key: "EUR",
				value: {
					type: "IBAN",
					iban: "GB33BUKB20201555555555"
				}
			}],
			appUrl: "https://www.example.com/app",
			customerPortalEnabled: !0,
			includeBeneficiaryAddressInPaymentDetails: !1,
			ccMerchantOnInvoiceEmails: !0,
			showUsageInCustomerPortal: !0,
			supportEmail: "support@example.com",
			supportUrl: "https://www.example.com/support",
			customerPortalAuthRequirement: "REQUIRED"
		}
	}
}), Dn = "sequenceAccountSettings", On = "sequenceAccountId", kn = "sequenceAccount", An = "sequenceAccountMembers", jn = /* @__PURE__ */ e({ getSequenceAccountId: () => Mn }), Mn = t({
	route: () => "/sequence-account-id",
	queryKey: [On],
	mocking: {
		match: /\/api\/sequence-account-id$/,
		mock: { id: "sequence-account-id-123" }
	}
}), Nn = /* @__PURE__ */ e({ getSequenceAccountSettings: () => Pn }), Pn = t({
	route: () => "/sequence-account-settings",
	queryKey: [Dn],
	mocking: {
		match: /\/api\/sequence-account-settings$/,
		mock: {
			id: "sequence-account-settings-123",
			sequenceAccountId: "sequence-account-123",
			enabledCurrencies: ["USD"],
			accountingLockDate: null
		}
	}
}), Fn = /* @__PURE__ */ e({ putSequenceAccountSettings: () => In }), In = n({
	route: () => "/sequence-account-settings",
	method: "PUT",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [Dn],
	mocking: {
		match: /\/api\/sequence-account-settings$/,
		mock: {
			id: "sequence-account-settings-123",
			sequenceAccountId: "sequence-account-123",
			enabledCurrencies: ["USD"],
			accountingLockDate: null
		}
	}
}), Ln = /* @__PURE__ */ e({ getSequenceAccount: () => Rn }), Rn = t({
	route: ({ id: e }) => `/sequence-accounts/${e}`,
	queryKey: [kn],
	mocking: {
		match: /\/api\/sequence-accounts\/[^\/]+$/,
		mock: {
			id: "13448448-ce43-4874-8acf-8ff2a8ca24c1",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceOrganisationId: "02441bde-24e8-43d5-8e2d-f3e480778885",
			companyName: "Acme Inc.",
			companyNumber: "GB123987",
			country: "GB",
			sendCustomerNotifications: !0,
			alertEmailAddresses: ["alerts@example.com"]
		}
	}
}), zn = /* @__PURE__ */ e({ postSequenceAccountInvite: () => Bn }), Bn = n({
	route: () => "/sequence-accounts/invite",
	body: ({ email: e }) => JSON.stringify({ email: e }),
	invalidateQueries: [An],
	method: "POST",
	mocking: {
		match: /\/api\/sequence-accounts\/invite$/,
		mock: void 0
	}
}), Vn = /* @__PURE__ */ e({ putSequenceAccount: () => Hn }), Hn = n({
	route: ({ id: e }) => `/sequence-accounts/${e}`,
	body: ({ alertEmailAddresses: e }) => JSON.stringify({ alertEmailAddresses: e }),
	invalidateQueries: [kn],
	method: "PUT",
	mocking: {
		match: /\/api\/sequence-accounts\/[^\/]+$/,
		mock: {
			id: "13448448-ce43-4874-8acf-8ff2a8ca24c1",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceOrganisationId: "02441bde-24e8-43d5-8e2d-f3e480778885",
			companyName: "Acme Inc.",
			companyNumber: "GB123987",
			country: "GB",
			sendCustomerNotifications: !0,
			alertEmailAddresses: ["alerts@example.com"]
		}
	}
}), Un = /* @__PURE__ */ e({}), Wn = {
	getMerchantForSequenceAccount: En,
	getSequenceAccountId: Mn,
	getSequenceAccountSettings: Pn,
	putSequenceAccountSettings: In,
	getSequenceAccount: Rn,
	postSequenceAccountInvite: Bn,
	putSequenceAccount: Hn
}, B = "integrations", V = "integrationCustomers", Gn = "integrationProducts", H = "linkedEntities", Kn = "hubspotCompanyDeals", qn = /* @__PURE__ */ e({ getAllIntegrationCustomers: () => Jn }), Jn = t({
	route: () => "/integrations/customers",
	queryKey: [V],
	mocking: {
		match: /\/api\/integrations\/customers$/,
		mock: { customers: [{
			key: "Xero",
			value: [{
				id: "id",
				companyName: "My customer",
				country: "GB",
				isLinked: !0,
				invalidReason: "Address line 1 is missing.",
				validationErrors: [{
					field: "address.line1",
					problem: "MISSING"
				}],
				externalUrl: "www.example.com"
			}]
		}] }
	}
}), Yn = /* @__PURE__ */ e({ getIntegration: () => Xn }), Xn = t({
	route: (e) => `/integrations/${e}`,
	queryKey: [B],
	mocking: {
		match: /\/api\/integrations\/(.+)$/,
		mock: {
			state: "UNAVAILABLE",
			enabled: !1,
			service: "Xero",
			paymentSyncEnabled: !1,
			type: "Accounting",
			authFailure: !1,
			bankAccounts: [],
			settings: { paymentBankAccounts: [] },
			ledgerAccounts: {
				defaults: {
					chargeAccount: void 0,
					creditAccount: void 0,
					minimumAccount: void 0,
					taxLiabilityAccount: void 0
				},
				options: [{
					id: "id",
					code: "200",
					name: "Sales"
				}]
			},
			taxCodes: {
				defaults: { untaxedCustomerTaxCode: "NONE" },
				options: [{
					name: "None",
					taxType: "NONE"
				}]
			}
		}
	}
}), Zn = /* @__PURE__ */ e({ deleteLinkedEntity: () => Qn }), Qn = n({
	route: ({ type: e, id: t, service: n }) => `/linked-entities/${e}/${t}/${n}`,
	method: "DELETE",
	invalidateQueries: [
		H,
		B,
		a
	],
	mocking: {
		match: /\/api\/linked-entities\/(.+)\/(.+)\/(.+)$/,
		mock: void 0
	}
}), $n = /* @__PURE__ */ e({ getIntegrationCustomersService: () => er }), er = t({
	route: ({ service: e, queryParams: t }) => `/integrations/customers/${e}${s(t)}`,
	queryKey: [V],
	mocking: {
		match: /\/api\/integrations\/customers\/([^?]+)(\?.*)?$/,
		mock: { items: [] }
	}
}), tr = /* @__PURE__ */ e({ getHubspotCompanyDeals: () => nr }), nr = t({
	route: ({ companyId: e }) => `/hubspot/companies/${e}/deals`,
	queryKey: [Kn],
	mocking: {
		match: /\/api\/hubspot\/companies\/(.+)\/deals$/,
		mock: {
			deals: [{
				dealId: "146000123",
				name: "Acme renewal",
				dealStage: "closedwon",
				dealStageLabel: "Closed won",
				amount: {
					currency: "USD",
					value: "1000.50"
				}
			}],
			truncated: !1
		}
	}
}), rr = /* @__PURE__ */ e({ putHubspotDealQuoteLink: () => ir }), ir = n({
	route: ({ dealId: e }) => `/hubspot/deals/${encodeURIComponent(e)}/quote`,
	method: "PUT",
	body: ({ quoteId: e }) => JSON.stringify({ quoteId: e }),
	invalidateQueries: [
		M,
		H,
		B
	],
	mocking: {
		match: /\/api\/hubspot\/deals\/(.+)\/quote$/,
		mock: {
			dealId: "146000123",
			quoteId: "0198a1b2-c3d4-7e5f-8a9b-0c1d2e3f4a5b",
			linkId: "0198a1b2-c3d4-7e5f-8a9b-0c1d2e3f4a6c"
		}
	}
}), ar = /* @__PURE__ */ e({ deleteHubspotDealQuoteLink: () => or }), or = n({
	route: ({ dealId: e }) => `/hubspot/deals/${encodeURIComponent(e)}/quote`,
	method: "DELETE",
	invalidateQueries: [
		M,
		H,
		B
	],
	mocking: {
		match: /\/api\/hubspot\/deals\/(.+)\/quote$/,
		mock: {
			dealId: "146000123",
			unlinkedQuoteId: "0198a1b2-c3d4-7e5f-8a9b-0c1d2e3f4a5b"
		}
	}
}), sr = /* @__PURE__ */ e({ getIntegrationProductsService: () => cr }), cr = t({
	route: (e) => `/integrations/products/${e}`,
	queryKey: [Gn],
	mocking: {
		match: /\/api\/integrations\/products\/(.+)$/,
		mock: { items: [{
			id: "123",
			name: "Product 1",
			isLinked: !0,
			externalUrl: "https://example.com/product/123"
		}, {
			id: "456",
			name: "Product 2",
			isLinked: !1,
			externalUrl: "https://example.com/product/456"
		}] }
	}
}), U = "automations.manual-tasks", W = "automations.admin-manual-tasks", lr = "automations.automations", ur = "automations.automation-versions", dr = "automations.automation-executions", fr = "creditNotesSettings", pr = "creditNotes", mr = "creditNotesCsvDownload", hr = "creditNotesPdfDownload", gr = /* @__PURE__ */ e({ postPushCreditNoteToExternalService: () => _r }), _r = n({
	route: ({ service: e, creditNoteId: t }) => `/integrations/${e}/sync-credit-note/${t}`,
	method: "POST",
	invalidateQueries: [
		pr,
		U,
		W
	],
	mocking: {
		match: /\/api\/integrations\/(.+)\/sync-credit-note\/(.+)$/,
		mock: void 0
	}
}), vr = /* @__PURE__ */ e({ postPushCreditNoteApplicationToExternalService: () => yr }), yr = n({
	route: ({ service: e, creditNoteId: t, ledgerTransactionId: n }) => `/integrations/${e}/credit-notes/${t}/push-credit-note-application/${n}`,
	method: "POST",
	invalidateQueries: [U, W],
	mocking: {
		match: /\/api\/integrations\/(.+)\/credit-notes\/(.+)\/push-credit-note-application\/(.+)$/,
		mock: void 0
	}
}), br = /* @__PURE__ */ e({ postPushPaymentToExternalService: () => xr }), xr = n({
	route: ({ service: e, paymentId: t }) => `/integrations/${e}/push-payment/${t}`,
	method: "POST",
	invalidateQueries: [U, W],
	mocking: {
		match: /\/api\/integrations\/(.+)\/push-payment\/(.+)$/,
		mock: void 0
	}
}), Sr = /* @__PURE__ */ e({ postPushInvoiceToExternalService: () => Cr }), Cr = n({
	route: ({ service: e, invoiceId: t }) => `/integrations/${e}/sync-invoice/${t}`,
	method: "POST",
	invalidateQueries: [d],
	mocking: {
		match: /\/api\/integrations\/(.+)\/sync-invoice\/(.+)$/,
		mock: void 0
	}
}), wr = /* @__PURE__ */ e({ postPushCustomerToExternalService: () => Tr }), Tr = n({
	route: (e) => `/integrations/${e.service}/push-customer/${e.customerId}`,
	method: "POST",
	body: (e) => "data" in e ? JSON.stringify(e.data) : JSON.stringify({}),
	invalidateQueries: [V, a],
	mocking: {
		match: /\/api\/integrations\/(.+)\/push-customer\/(.+)$/,
		mock: void 0
	}
}), Er = /* @__PURE__ */ e({ postPushProductToExternalService: () => Dr }), Dr = n({
	route: (e) => `/integrations/${e.service}/push-product/${e.productId}`,
	method: "POST",
	body: (e) => JSON.stringify({ incomeAccountId: e.incomeAccountId }),
	invalidateQueries: [Gn, fe],
	mocking: {
		match: /\/api\/integrations\/(.+)\/push-product\/(.+)$/,
		mock: void 0
	}
}), Or = /* @__PURE__ */ e({ postValidateExternalEntity: () => kr }), kr = n({
	route: ({ service: e }) => `/integrations/${e}/validate-external-entity`,
	method: "POST",
	body: ({ id: e, entityType: t }) => JSON.stringify({
		externalEntityId: e,
		externalEntityType: t
	}),
	invalidateQueries: [],
	mocking: {
		match: /\/api\/integrations\/(.+)\/validate-external-entity$/,
		mock: {
			isValid: !0,
			name: "Opportunity 1"
		}
	}
}), Ar = /* @__PURE__ */ e({ postCreateGoogleSheetsInsightsExport: () => jr }), jr = n({
	route: () => "/integrations/google-sheets/export",
	body: ({ template: e, sheetUrl: t }) => JSON.stringify({
		template: e,
		sheetUrl: t
	}),
	method: "POST",
	invalidateQueries: [],
	mocking: {
		match: /\/api\/integrations\/google-sheets\/export/,
		mock: void 0
	}
}), Mr = /* @__PURE__ */ e({ postCreateCustomerFromExternalService: () => Nr }), Nr = n({
	route: ({ service: e }) => `/integrations/${e}/customers`,
	method: "POST",
	body: ({ customerIds: e }) => JSON.stringify({ customerIds: e }),
	invalidateQueries: [a, V],
	mocking: {
		match: /\/api\/integrations\/(.+)\/customers$/,
		mock: { count: 1 }
	}
}), Pr = /* @__PURE__ */ e({ postCreateCustomerFromExternalServiceProgress: () => Fr }), Fr = t({
	route: ({ service: e }) => `/integrations/${e}/customers/progress`,
	method: "POST",
	body: ({ customerIds: e, startedAt: t }) => JSON.stringify({
		customerIds: e,
		startedAt: t
	}),
	queryKey: [a, "import-progress"],
	mocking: {
		match: /\/api\/integrations\/(.+)\/customers\/progress$/,
		mock: {
			totalCount: 10,
			currentCount: 1,
			failures: []
		}
	}
}), Ir = /* @__PURE__ */ e({ postSyncInvoiceWithExternalService: () => Lr }), Lr = n({
	route: ({ service: e, invoiceId: t }) => `/integrations/${e}/sync-invoice/${t}`,
	method: "POST",
	invalidateQueries: [],
	mocking: {
		match: /\/api\/integrations\/(.+)\/sync-invoice\/(.+)$/,
		mock: void 0
	}
}), Rr = /* @__PURE__ */ e({ postSyncHubspotCustomers: () => zr }), zr = n({
	route: () => "/integrations/HubSpot/sync/customers",
	method: "POST",
	body: ({ customers: e }) => JSON.stringify({ customers: e }),
	invalidateQueries: [a, V],
	mocking: {
		match: /\/api\/integrations\/HubSpot\/sync\/customers$/,
		mock: {
			taskId: "mock-task-id",
			startedAt: "2026-01-01T00:00:00Z"
		}
	}
}), Br = /* @__PURE__ */ e({ putHubspotSettings: () => Vr }), Vr = n({
	route: () => "/hubspot/settings",
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [B, V],
	mocking: {
		match: /\/api\/hubspot\/settings$/,
		mock: {
			customerImportStages: ["closedwon"],
			signedQuoteStage: "closedwon",
			renewalDealCreation: "ENABLED",
			pdfSyncOnSign: "SYNC",
			dealAmountSync: "SYNC"
		}
	}
}), Hr = /* @__PURE__ */ e({ putQuickbooksSettings: () => Ur }), Ur = n({
	route: () => "/quickbooks/settings",
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [B],
	mocking: {
		match: /\/api\/quickbooks\/settings$/,
		mock: { paymentBankAccounts: [{
			currency: "GBP",
			bankAccountId: "35"
		}, {
			currency: "USD",
			bankAccountId: "81"
		}] }
	}
}), Wr = /* @__PURE__ */ e({ putXeroSettings: () => Gr }), Gr = n({
	route: () => "/integrations/Xero/settings",
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [B],
	mocking: {
		match: /\/api\/integrations\/Xero\/settings$/,
		mock: { paymentBankAccounts: [{
			currency: "USD",
			bankAccountId: "abc"
		}] }
	}
}), Kr = {
	getAllIntegrationCustomers: Jn,
	getIntegration: Xn,
	deleteLinkedEntity: Qn,
	getIntegrationCustomersService: er,
	getHubspotCompanyDeals: nr,
	putHubspotDealQuoteLink: ir,
	deleteHubspotDealQuoteLink: or,
	getIntegrationProductsService: cr,
	postPushCreditNoteToExternalService: _r,
	postPushCreditNoteApplicationToExternalService: yr,
	postPushPaymentToExternalService: xr,
	postPushInvoiceToExternalService: Cr,
	postPushCustomerToExternalService: Tr,
	postPushProductToExternalService: Dr,
	postValidateExternalEntity: kr,
	postCreateGoogleSheetsInsightsExport: jr,
	postCreateCustomerFromExternalService: Nr,
	postCreateCustomerFromExternalServiceProgress: Fr,
	postSyncInvoiceWithExternalService: Lr,
	postSyncHubspotCustomers: zr,
	putHubspotSettings: Vr,
	putQuickbooksSettings: Ur,
	putXeroSettings: Gr
}, G = "insights", qr = `${G}.usageEvents`, Jr = `${G}.customerTotals`, Yr = `${G}.outstandingInvoices`, Xr = `${G}.invoicedRevenue`, Zr = `${G}.usageData`, Qr = /* @__PURE__ */ e({ getInsightsUsageEvents: () => $r }), $r = t({
	route: (e) => `/insights/usage-events${s(e)}`,
	queryKey: [qr],
	mocking: {
		match: /\/insights\/usage-events(\?(.*))?$/,
		mock: {
			totalEventCount: 5,
			eventsByDay: [{
				eventCount: 3,
				date: "2024-01-01"
			}, {
				eventCount: 2,
				date: "2024-01-02"
			}]
		}
	}
}), ei = /* @__PURE__ */ e({ getInsightsCustomerTotals: () => ti }), ti = t({
	route: () => "/insights/customer-totals",
	queryKey: [Jr],
	mocking: {
		match: /\/insights\/customer-totals$/,
		mock: {
			total: 4,
			numCustomersWithActiveSchedule: 2,
			numCustomersNoLongerBilled: 1,
			numCustomersNeverBilled: 1
		}
	}
}), ni = /* @__PURE__ */ e({ getInsightsOutstandingInvoices: () => ri }), ri = t({
	route: (e) => `/insights/outstanding-invoices${s(e)}`,
	queryKey: [Yr],
	mocking: {
		match: /\/insights\/outstanding-invoices(\?(.*))?$/,
		mock: {
			currency: "GBP",
			totalAmount: 4900,
			outstandingNow: {
				numberOfInvoices: 1,
				amount: 1900
			},
			overdueFrom0to30days: {
				numberOfInvoices: 1,
				amount: 1e3
			},
			overdueFrom31to60days: {
				numberOfInvoices: 1,
				amount: 1e3
			},
			overdueFrom61days: {
				numberOfInvoices: 1,
				amount: 1e3
			}
		}
	}
}), ii = /* @__PURE__ */ e({ getInsightsInvoicedRevenue: () => ai }), ai = t({
	route: (e) => `/insights/invoiced-revenue${s(e)}`,
	queryKey: [Xr],
	mocking: {
		match: /\/insights\/invoiced-revenue(\?(.*))?$/,
		mock: {
			currency: "GBP",
			totalAmount: 9400,
			invoicedRevenueByMonth: [{
				amount: 4900,
				periodStart: "2024-01-01"
			}, {
				amount: 4500,
				periodStart: "2024-02-01"
			}]
		}
	}
}), oi = /* @__PURE__ */ e({ getInsightsUsageData: () => si }), si = t({
	route: ({ usageMetricId: e, ...t }) => `/insights/usage-metrics/${e}/usage-data${s(t)}`,
	queryKey: [Zr],
	config: { responseTransform: (e) => e.json().then(({ data: e }) => e) },
	mocking: {
		match: /\/insights\/usage-metrics\/.*\/usage-data(\?(.*))?$/,
		mock: {
			usageStart: "2024-01-01",
			usageEnd: "2024-01-03",
			metricName: "API Calls",
			metricId: "030a64dd-1d89-46a3-8043-580befdb011d",
			total: "35",
			usageData: [
				{
					periodStart: "2024-01-01",
					amount: "10",
					cumulativeAmount: "10"
				},
				{
					periodStart: "2024-01-02",
					amount: "15",
					cumulativeAmount: "25"
				},
				{
					periodStart: "2024-01-03",
					amount: "10",
					cumulativeAmount: "35"
				}
			]
		}
	}
}), ci = {
	getInsightsUsageEvents: $r,
	getInsightsCustomerTotals: ti,
	getInsightsOutstandingInvoices: ri,
	getInsightsInvoicedRevenue: ai,
	getInsightsUsageData: si
}, K = "taxRates", li = /* @__PURE__ */ e({ getTaxRates: () => ui }), ui = t({
	route: (e) => `/tax-rates${s(e)}`,
	queryKey: [K],
	mocking: {
		match: /\/api\/tax-rates(\?(.*))?$/,
		mock: {
			items: [{
				id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
				versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
				version: 0,
				isPublished: !1,
				name: "UK Sales Tax",
				invoiceName: "Value Added Tax",
				invoiceShortName: "VAT",
				amount: "0.2",
				country: "GB",
				taxCategoryId: "ce109c64-dcc0-487a-ac8c-e3237c60cdb6",
				isArchived: !1
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), di = /* @__PURE__ */ e({ postNewTaxRateVersion: () => fi }), fi = n({
	route: ({ id: e }) => `/tax-rates/${e}/versions`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [K],
	mocking: {
		match: /\/api\/tax-rates\/(.+)\/versions$/,
		mock: {
			id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 1,
			isPublished: !1,
			name: "UK Sales Tax",
			invoiceName: "Value Added Tax",
			invoiceShortName: "VAT",
			description: "Value Added Tax applied to sales in the UK",
			amount: "0.2",
			country: "GB",
			taxCategoryId: "ce109c64-dcc0-487a-ac8c-e3237c60cdb6",
			isArchived: !1
		}
	}
}), pi = /* @__PURE__ */ e({ postTaxRate: () => mi }), mi = n({
	route: () => "/tax-rates",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [K],
	mocking: {
		match: /\/api\/tax-rates$/,
		mock: {
			id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 0,
			isPublished: !1,
			name: "UK Sales Tax",
			invoiceName: "Value Added Tax",
			invoiceShortName: "VAT",
			description: "Value Added Tax applied to sales in the UK",
			amount: "0.2",
			country: "GB",
			taxCategoryId: "ce109c64-dcc0-487a-ac8c-e3237c60cdb6",
			isArchived: !1
		}
	}
}), hi = /* @__PURE__ */ e({ putTaxRate: () => gi }), gi = n({
	route: ({ id: e }) => `/tax-rates/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [K],
	mocking: {
		match: /\/api\/tax-rates\/(.+)$/,
		mock: {
			id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 0,
			isPublished: !1,
			name: "UK Sales Tax",
			invoiceName: "Value Added Tax",
			invoiceShortName: "VAT",
			description: "Value Added Tax applied to sales in the UK",
			amount: "0.2",
			country: "GB",
			taxCategoryId: "ce109c64-dcc0-487a-ac8c-e3237c60cdb6",
			isArchived: !1
		}
	}
}), _i = /* @__PURE__ */ e({ postArchiveTaxRate: () => vi }), vi = n({
	route: ({ id: e }) => `/tax-rates/${e}/archive`,
	method: "POST",
	invalidateQueries: [K],
	mocking: {
		match: /\/api\/tax-rates\/(.+)\/archive$/,
		mock: {
			id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6",
			version: 0,
			isPublished: !1,
			name: "UK Sales Tax",
			invoiceName: "Value Added Tax",
			invoiceShortName: "VAT",
			description: "Value Added Tax applied to sales in the UK",
			amount: "0.2",
			country: "GB",
			region: "London",
			taxCategoryId: "ce109c64-dcc0-487a-ac8c-e3237c60cdb6",
			isArchived: !0
		}
	}
}), yi = {
	getTaxRates: ui,
	postNewTaxRateVersion: fi,
	postTaxRate: mi,
	putTaxRate: gi,
	postArchiveTaxRate: vi
}, q = "seatMetrics", J = "seatEvents", Y = "seatBalances", bi = "seatTotals", xi = /* @__PURE__ */ e({ getSeatEvent: () => Si }), Si = t({
	route: (e) => `/seat-events/${e.id}`,
	queryKey: [J],
	mocking: {
		match: /\/api\/seat-events\/(.+)$/,
		mock: {
			id: "seat-event-123",
			customerAlias: "customer-alias-123",
			customerEventId: "customer-event-123",
			seatType: "seat",
			sequenceAccountId: "sequence-account-123",
			total: 12,
			eventTimestamp: "2023-09-01T10:00:00.000Z"
		}
	}
}), Ci = /* @__PURE__ */ e({ getSeatBalances: () => wi }), wi = t({
	route: (e) => `/seat-balances${s(e)}`,
	queryKey: [Y],
	mocking: {
		match: /\/api\/seat-balances(\?(.*))?$/,
		mock: {
			items: [{
				id: "test-8202-70ea-a729-30308a40bbf7",
				sequenceAccountId: "",
				legalName: "test-customer",
				customerAliases: ["test-customer"],
				total: 10,
				changeTimestamp: "2023-09-01T10:00:00.000Z",
				balances: [{
					seatType: "administrator",
					total: 10,
					changeTimestamp: "2023-09-01T10:00:00.000Z"
				}]
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Ti = /* @__PURE__ */ e({ getSeatEvents: () => Ei }), Ei = t({
	route: (e) => `/seat-events${s(e)}`,
	queryKey: [J],
	mocking: {
		match: /\/api\/seat-events(\?(.*))?$/,
		mock: {
			items: [{
				id: "seat-event-123",
				customerAlias: "customer-alias-123",
				customerEventId: "customer-event-123",
				seatType: "seat",
				sequenceAccountId: "sequence-account-123",
				total: 12,
				eventTimestamp: "2023-09-01T10:00:00.000Z"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Di = /* @__PURE__ */ e({ getSeatMetrics: () => Oi }), Oi = t({
	route: (e) => `/seat-metrics${s(e)}`,
	queryKey: [q],
	mocking: {
		match: /\/api\/seat-metrics(\?(.*))?$/,
		mock: {
			items: [{
				id: "seat-metric-123",
				seatType: "seat",
				label: "Seat",
				description: "A seat of mine",
				createdAt: "2023-09-01T10:00:00.000Z",
				updatedAt: "2023-09-01T11:00:00.000Z"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), ki = /* @__PURE__ */ e({ postSeatEvent: () => Ai }), Ai = n({
	route: () => "/seat-events",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [J, Y],
	mocking: {
		match: /\/api\/seat-events$/,
		mock: {
			id: "seat-event-123",
			customerAlias: "customer-alias-123",
			customerEventId: "customer-event-123",
			seatType: "seat",
			sequenceAccountId: "sequence-account-123",
			total: 12,
			eventTimestamp: "2023-09-01T10:00:00.000Z"
		}
	}
}), ji = /* @__PURE__ */ e({ postSeatMetric: () => Mi }), Mi = n({
	route: () => "/seat-metrics",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [q, Y],
	mocking: {
		match: /\/api\/seat-metrics$/,
		mock: {
			label: "Test Seat Metric",
			seatType: "Test Seat Type",
			description: "Test Description",
			id: "seat-metric-123",
			createdAt: "2023-09-01T10:00:00.000Z",
			updatedAt: "2023-09-01T11:00:00.000Z"
		}
	}
}), Ni = /* @__PURE__ */ e({ getSeatTotals: () => Pi }), Pi = t({
	route: (e = {}) => `/latest-seat-totals${s({
		...e,
		customerAliases: e.customerAliases ? e.customerAliases.join(",") : void 0,
		seatTypes: e.seatTypes ? e.seatTypes.join(",") : void 0
	})}`,
	queryKey: [bi],
	mocking: {
		match: /\/api\/latest-seat-totals(\?(.*))?$/,
		mock: {
			items: [{
				id: "0184421a-8202-70ea-a729-30308a40bbf7",
				customerAlias: "customer-id-2H4u5BBwBWsS5V2sroRFqJfTXpW",
				seatType: "admin",
				total: 10,
				changeTimestamp: "2022-06-28T16:47:00Z"
			}],
			pagination: {
				after: "MDE4NDUyNjYtNmQ2NC03N2M4LTlhZGYtNDQ4N2Q5NGQxNDU3",
				before: "MDE4NDQyMWUtYTljYy03MTFiLWFmOTMtYmYwNTExZDRkODMz",
				totalResultSize: 1
			}
		}
	}
}), Fi = /* @__PURE__ */ e({ getSeatMetric: () => Ii }), Ii = t({
	route: ({ id: e }) => `/seat-metrics/${e}`,
	queryKey: [q],
	mocking: {
		match: /\/api\/seat-metrics\/(.+)$/,
		mock: {
			id: "bc61d4b8-e9d6-4f4a-9bcf-f5dae874c730",
			seatType: "admin",
			createdBy: "4ffd439e-32e5-4046-bb40-3cb81f40e5da",
			label: "Administrator",
			description: "Allows user to make admin changes over whole account",
			createdAt: "2022-06-28T16:47:00Z",
			updatedAt: "2022-06-28T16:47:00Z"
		}
	}
}), Li = /* @__PURE__ */ e({ putSeatMetric: () => Ri }), Ri = n({
	route: ({ id: e }) => `/seat-metrics/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [q, Y],
	mocking: {
		match: /\/api\/seat-metrics\/(.+)$/,
		mock: {
			label: "Updated Seat Metric",
			seatType: "admin",
			description: "Updated description",
			id: "seat-metric-123",
			createdAt: "2023-09-01T10:00:00.000Z",
			updatedAt: "2023-09-01T11:00:00.000Z"
		}
	}
}), zi = /* @__PURE__ */ e({}), Bi = {
	getSeatEvent: Si,
	getSeatBalances: wi,
	getSeatEvents: Ei,
	getSeatMetrics: Oi,
	postSeatEvent: Ai,
	postSeatMetric: Mi,
	putSeatMetric: Ri,
	getSeatTotals: Pi,
	getSeatMetric: Ii
}, Vi = /* @__PURE__ */ e({ getPrice: () => Hi }), Hi = t({
	route: (e) => `/prices/${e.id}`,
	queryKey: [Mt],
	mocking: {
		match: /\/api\/prices\/(.+)$/,
		mock: {
			id: "price-123",
			name: "Example Price",
			productId: "product-123",
			structure: {
				pricingType: "ONE_TIME",
				price: "10.00"
			},
			currency: "USD",
			createdAt: "2024-06-11",
			integrationIds: [{
				service: "Xero",
				id: "foo"
			}],
			billingFrequency: "ONE_TIME",
			billingType: "IN_ARREARS",
			customMetricParameters: []
		}
	}
}), Ui = /* @__PURE__ */ e({ getPriceMetadata: () => Wi }), Wi = t({
	route: ({ id: e }) => `/prices/${e}/metadata`,
	queryKey: [k],
	mocking: {
		match: /\/api\/prices\/([^/]+)\/metadata/,
		mock: { billingSchedules: [{
			billingScheduleId: "e309e948-088e-4d77-b654-cd85498f1555",
			customerLegalName: "John Doe",
			customerId: "cca32597-b6b0-4499-9669-128aef8702e4"
		}] }
	}
}), Gi = /* @__PURE__ */ e({}), Ki = {
	getPrice: Hi,
	getPriceMetadata: Wi
}, X = "notificationsPolicies", qi = /* @__PURE__ */ e({ getAllNotificationPolicies: () => Ji }), Ji = t({
	route: ({ limit: e = 100, ...t } = {}) => `/notifications/policies${s({
		limit: e,
		...t
	})}`,
	queryKey: [X],
	mocking: {
		match: /\/api\/notifications\/policies(\?(.*))?$/,
		mock: {
			items: [{
				id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
				createdAt: "2022-06-28T16:47:00Z",
				sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
				name: "Finance team emails",
				notificationTypes: ["CUSTOMER_CREATED"],
				recipients: ["finance@example.com"],
				channel: "EMAIL"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Yi = /* @__PURE__ */ e({ deleteNotificationPolicy: () => Xi }), Xi = n({
	route: ({ id: e }) => `/notifications/policies/${e}`,
	method: "DELETE",
	invalidateQueries: [X],
	mocking: {
		match: /\/api\/notifications\/policies\/(.*)$/,
		mock: {
			id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
			name: "Finance team emails",
			notificationTypes: ["CUSTOMER_CREATED"],
			recipients: ["finance@example.com"],
			channel: "EMAIL"
		}
	}
}), Zi = /* @__PURE__ */ e({ postNotificationPolicy: () => Qi }), Qi = n({
	route: () => "/notifications/policies",
	body: (e) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [X],
	mocking: {
		match: /\/api\/notifications\/policies$/,
		mock: {
			id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
			name: "Finance team emails",
			notificationTypes: ["CUSTOMER_CREATED"],
			recipients: ["finance@example.com"],
			channel: "EMAIL"
		}
	}
}), $i = /* @__PURE__ */ e({ getNotificationPolicy: () => ea }), ea = t({
	route: ({ id: e }) => `/notifications/policies/${e}`,
	queryKey: [X],
	mocking: {
		match: /\/api\/notifications\/policies\/(.+)/,
		mock: {
			id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
			name: "Finance team emails",
			notificationTypes: ["CUSTOMER_CREATED"],
			recipients: ["finance@example.com"],
			channel: "EMAIL"
		}
	}
}), ta = /* @__PURE__ */ e({ postNotificationPolicyRecipients: () => Z }), Z = n({
	route: ({ id: e }) => `/notifications/policies/${e}/recipients`,
	body: ({ recipients: e }) => JSON.stringify({ recipients: e }),
	method: "POST",
	invalidateQueries: [X],
	mocking: {
		match: /\/api\/notifications\/policies\/([^/]+)\/recipients$/,
		mock: {
			id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
			name: "Finance team emails",
			notificationTypes: ["CUSTOMER_CREATED"],
			recipients: ["finance@example.com"],
			channel: "EMAIL"
		}
	}
}), na = /* @__PURE__ */ e({ deleteNotificationPolicyRecipients: () => ra }), ra = n({
	route: ({ id: e, recipient: t }) => `/notifications/policies/${e}/recipients/${t}`,
	method: "DELETE",
	invalidateQueries: [X],
	mocking: {
		match: /\/api\/notifications\/policies\/([^/]+)\/recipients\/(.+)$/,
		mock: {
			id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
			name: "Finance team emails",
			notificationTypes: ["CUSTOMER_CREATED"],
			recipients: ["finance@example.com"],
			channel: "EMAIL"
		}
	}
}), ia = /* @__PURE__ */ e({ postNotificationPolicyType: () => aa }), aa = n({
	route: ({ id: e }) => `/notifications/policies/${e}/notification-types`,
	body: ({ notificationTypes: e }) => JSON.stringify({ notificationTypes: e }),
	method: "POST",
	invalidateQueries: [X],
	mocking: {
		match: /\/api\/notifications\/policies\/([^/]+)\/notification-types$/,
		mock: {
			id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
			name: "Finance team emails",
			notificationTypes: ["CUSTOMER_CREATED"],
			recipients: ["finance@example.com"],
			channel: "EMAIL"
		}
	}
}), oa = /* @__PURE__ */ e({ deleteNotificationPolicyType: () => sa }), sa = n({
	route: ({ id: e, notificationType: t }) => `/notifications/policies/${e}/notification-types/${t}`,
	method: "DELETE",
	invalidateQueries: [X],
	mocking: {
		match: /\/api\/notifications\/policies\/([^/]+)\/notification-types\/([^/]+)$/,
		mock: {
			id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
			name: "Finance team emails",
			notificationTypes: ["CUSTOMER_CREATED"],
			recipients: ["finance@example.com"],
			channel: "EMAIL"
		}
	}
}), ca = {
	getAllNotificationPolicies: Ji,
	deleteNotificationPolicy: Xi,
	postNotificationPolicy: Qi,
	getNotificationPolicy: ea,
	postNotificationPolicyRecipients: Z,
	deleteNotificationPolicyRecipients: ra,
	postNotificationPolicyType: aa,
	deleteNotificationPolicyType: sa
}, la = /* @__PURE__ */ e({ getCreditNotesCsvDownload: () => ua }), ua = t({
	route: (e) => `/credit-notes/credit-notes-csv${s(e)}`,
	config: { responseTransform: (e) => e.blob() },
	queryKey: [mr],
	mocking: {
		match: /\/api\/credit-notes\/credit-notes-csv(\?(.*))?$/,
		mock: new Blob([""], { type: "text/csv" })
	}
}), da = /* @__PURE__ */ e({ getCreditNotesSettings: () => fa }), fa = t({
	route: () => "/credit-notes-settings",
	queryKey: [fr],
	mocking: {
		match: /\/api\/credit-notes-settings$/,
		mock: { generateCashCreditGrant: "ENABLED" }
	}
}), pa = /* @__PURE__ */ e({ putCreditNotesSettings: () => ma }), ma = n({
	route: () => "/credit-notes-settings",
	body: ({ body: e }) => JSON.stringify(e),
	method: "PUT",
	invalidateQueries: [fr],
	mocking: {
		match: /\/api\/credit-notes-settings$/,
		mock: { generateCashCreditGrant: "ENABLED" }
	}
}), ha = /* @__PURE__ */ e({ getCreditNotePdf: () => ga }), ga = t({
	route: ({ id: e }) => `/credit-notes/${e}/download`,
	config: { responseTransform: (e) => e.blob() },
	queryKey: [hr],
	mocking: {
		match: /\/api\/credit-notes\/[^\/]+\/download$/,
		mock: new Blob([""], { type: "application/pdf" })
	}
}), _a = /* @__PURE__ */ e({ postIssueAndApplyCreditNote: () => va }), va = n({
	route: ({ id: e }) => `/credit-notes/${e}/issue-and-apply`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	headers: ({ idempotencyKey: e }) => ({ "Idempotency-Key": e ?? crypto.randomUUID() }),
	invalidateQueries: [pr, d],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/issue-and-apply$/,
		mock: {
			creditNote: {
				id: "af60cab3-812d-4250-a051-0fb7133a00c7",
				status: "SENT",
				invoiceId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				invoiceNumber: "INV00001",
				currency: "GBP",
				issueDate: "2022-09-15",
				accountingDate: "2022-09-15",
				billingPeriodStart: "2022-10-01T00:00:00Z",
				billingPeriodEnd: "2022-10-30T00:00:00Z",
				creditNoteNumber: "CN00001",
				customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				customerEmails: ["customer@example.com"],
				customerLegalCompanyName: "Facebook",
				customerBillingAddress: {
					line1: "Flat 1",
					line2: "15 Yemen Road",
					town: "Yemen",
					state: "CA",
					postcode: "YE1 2YE",
					country: "US"
				},
				customerShippingAddress: {
					line1: "742 Evergreen Terrace",
					town: "Springfield",
					state: "CA",
					postcode: "12345",
					country: "US"
				},
				memo: "Thanks",
				totalTax: "2.50",
				netTotal: "51.20",
				grossTotal: "101.23",
				metadata: [],
				linkedServices: [],
				sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
				settings: { generateCashCreditGrant: "DISABLED" }
			},
			application: {
				ledgerTransactionId: "b1f1f0a2-0c3d-4e5f-8a6b-7c8d9e0f1a2b",
				creditNoteId: "af60cab3-812d-4250-a051-0fb7133a00c7",
				invoiceId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				amount: "101.23",
				currency: "GBP",
				appliedAt: "2022-09-15T10:00:00Z",
				invoiceBalance: {
					value: "0.00",
					currency: "GBP",
					version: 2
				},
				creditNoteBalance: {
					value: "0.00",
					currency: "GBP",
					version: 2
				}
			}
		}
	}
}), ya = {
	getCreditNotesCsvDownload: ua,
	getCreditNotesSettings: fa,
	putCreditNotesSettings: ma,
	getCreditNotePdf: ga,
	postIssueAndApplyCreditNote: va
}, Q = "taxRegistrations", ba = {
	getTaxRegistrations: t({
		route: ({ customerId: e, ...t }) => `/tax-registrations/for-customer/${e}${s(t)}`,
		queryKey: [Q],
		mocking: {
			match: /\/api\/tax-registrations\/for-customer\/[^\/]+(\?(.*))?$/,
			mock: {
				items: [{
					id: "3271ca41-d538-404f-a15f-25856a37fb88",
					sequenceAccountId: "42020696-da25-44d0-ab79-9ecbf8fc5307",
					taxIdentifier: "CA123456789",
					customerId: "06457f78-85cd-4140-9972-67c6cd8f6071",
					country: "GB"
				}],
				pagination: {
					after: "",
					before: "",
					totalResultSize: 1
				}
			}
		}
	}),
	postTaxRegistration: n({
		route: () => "/tax-registrations",
		method: "POST",
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [Q],
		mocking: {
			match: /\/api\/tax-registrations$/,
			mock: {
				taxIdentifier: "123456789",
				country: "US",
				customerId: "cust-123",
				id: "123",
				sequenceAccountId: "seq-123",
				state: "AL"
			}
		}
	}),
	putTaxRegistration: n({
		route: ({ id: e }) => `/tax-registrations/${e}`,
		method: "PUT",
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [Q],
		mocking: {
			match: /\/api\/tax-registrations\/(.+)$/,
			mock: {
				taxIdentifier: "123456789",
				country: "US",
				customerId: "cust-123",
				id: "123",
				sequenceAccountId: "seq-123",
				state: "AL"
			}
		}
	}),
	deleteTaxRegistration: n({
		route: ({ id: e }) => `/tax-registrations/${e}`,
		method: "DELETE",
		invalidateQueries: [Q],
		mocking: {
			match: /\/api\/tax-registrations\/(.+)$/,
			mock: {
				taxIdentifier: "123456789",
				country: "US",
				customerId: "cust-123",
				id: "123",
				sequenceAccountId: "seq-123",
				state: "AL"
			}
		}
	})
}, xa = t({
	route: (e) => `/quotes${s(e)}`,
	queryKey: [M],
	mocking: {
		match: /\/api\/quotes(\?(.*))?$/,
		mock: {
			items: [{
				id: "018fbe90-cefa-79e5-b17a-a0a5525b38bc",
				createdBy: "46204534-85ba-4187-96d9-9cc5d7175b31",
				quoteNumber: "Q00130",
				acceptedAt: "2024-05-28T10:55:57.776435Z",
				isExpired: !1,
				title: "Foo",
				currency: "USD",
				customerId: "customer-123",
				publishedAt: "2024-05-28T10:55:57.776435Z",
				expiresAt: "2024-06-27",
				status: "PUBLISHED",
				dealType: "NEW_BUSINESS",
				createdAt: "2024-05-28T09:38:32.307766Z",
				updatedAt: "2024-05-28T10:55:57.776435Z",
				expiryDays: 30
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Sa = n({
	route: ({ id: e }) => `/quotes/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [M, N],
	mocking: {
		match: /\/api\/quotes\/([^/]+)$/,
		mock: {
			id: "018fbe90-cefa-79e5-b17a-a0a5525b38bc",
			createdBy: "46204534-85ba-4187-96d9-9cc5d7175b31",
			quoteNumber: "Q00130",
			title: "Foo",
			currency: "USD",
			pdfStatus: "NOT_YET_REQUESTED",
			presentation: [{
				config: { phases: [{
					id: "new-uuid",
					dates: {
						absolute: {
							end: "",
							start: ""
						},
						duration: { years: 1 }
					},
					prices: P,
					minimums: [{
						id: "new-minimum::944be936-ea22-4f37-8c6e-71eb1f682387",
						name: "",
						scope: {
							target: "allUsage",
							priceIds: []
						},
						value: "15.00"
					}],
					discounts: []
				}, {
					id: "new-phase::01723118-789f-435c-b398-619ac3982928",
					dates: {
						absolute: {
							end: "",
							start: ""
						},
						duration: { years: 1 }
					},
					prices: [{
						id: "new-price::60181225-95a0-4062-b89b-657de93404d3",
						name: "More dolla",
						productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
						structure: {
							price: "3500.00",
							pricingType: "FIXED"
						},
						parameters: [],
						billingType: "IN_ARREARS",
						externalIds: [],
						billingFrequency: "MONTHLY"
					}],
					minimums: [],
					discounts: [{
						id: "new-discount::25b1e237-136e-4c35-8cc0-53ea89a7d192",
						amount: 5,
						message: "New discount",
						priceIds: ["new-price::60181225-95a0-4062-b89b-657de93404d3"],
						applyToAllPrices: !1,
						discountCalculationType: "PERCENTAGE"
					}]
				}] },
				version: 1,
				blockType: "phases"
			}, {
				config: { text: [] },
				version: 1,
				blockType: "paragraph"
			}],
			customerId: "customer-123",
			publishedAt: "2024-05-28T10:55:57.776435Z",
			expiresAt: "2024-06-27",
			isExpired: !1,
			status: "PUBLISHED",
			dealType: "NEW_BUSINESS",
			createdAt: "2024-05-28T09:38:32.307766Z",
			updatedAt: "2024-05-28T10:55:57.776435Z",
			readyToSignAt: "2024-05-28T10:55:57.776435Z",
			expiryDays: 30,
			merchantBranding: {
				logoUrl: "https://backend-production-librarybucket-1izigk5lryla9.s3.amazonaws.com/48bc5c87-69dd-4d3a-b977-8a3ce36efefd/1695221702164_download.jpeg",
				legalCompanyName: "Kai Test",
				primaryColour: "#2A9EDB",
				address: {
					line1: "Foo",
					line2: "Bar",
					town: "Hixon't",
					postcode: "ST1 1AA",
					country: "GB"
				},
				email: "foo@bar.com"
			},
			phases: [{
				id: "018fbed7-b1aa-7baa-ade6-0f3faaa4982d",
				createdAt: "2024-05-28T10:55:57.866154Z",
				duration: {
					months: 0,
					years: 1
				},
				prices: P,
				discounts: [],
				minimums: [{
					id: "018fbed7-b1aa-7baa-ade7-54f102f362cc",
					amount: "15",
					restrictToPrices: [],
					createdAt: "2024-05-28T10:55:57.866181Z",
					updatedAt: "2024-05-28T10:55:57.866181Z"
				}]
			}, {
				id: "018fbed7-b1cf-719c-b46d-04554289888e",
				duration: {
					months: 0,
					years: 1
				},
				prices: [{
					id: "018fbed7-b1cb-782b-b331-eeb71fe1cea3",
					productId: "018ba4fd-3483-7460-a8e5-5f8fd555337e",
					name: "More dolla",
					createdAt: "2024-04-05",
					structure: {
						pricingType: "FIXED",
						price: "3500.00"
					},
					billingFrequency: "MONTHLY",
					billingType: "IN_ARREARS",
					integrationIds: [],
					customMetricParameters: []
				}],
				discounts: [{
					id: "018fbed7-b1cf-719c-b46e-7deb87e939e6",
					restrictToPrices: ["018fbed7-b1cb-782b-b331-eeb71fe1cea3"],
					amount: "5",
					discountCalculationType: "PERCENTAGE",
					message: "New discount",
					seatDiscountType: "ALL_SEATS"
				}],
				minimums: [{
					id: "13295b5e-d609-4e49-8ed5-38301cad9c6e",
					restrictToPrices: ["018fbed7-b1cb-782b-b331-eeb71fe1cea3"],
					amount: "5"
				}]
			}],
			contacts: [{
				contactId: "contact-1",
				name: "John",
				email: "john@example.com",
				signedAt: void 0
			}, {
				contactId: "contact-2",
				name: "Mary",
				email: "mary@example.com",
				signedAt: "2024-05-28T10:55:57.866181Z"
			}],
			counterSigners: [{
				id: "counter-signer-1",
				name: "Adam",
				email: "adam@example-pet-store.com",
				signedAt: void 0
			}, {
				id: "counter-signer-2",
				name: "Becky",
				email: "Becky@example-pet-store.com",
				signedAt: "2024-05-28T10:55:57.866181Z"
			}],
			isSignaturesEnabled: !0,
			attachmentAssets: [{
				id: "assetId",
				type: "IMAGE",
				url: "url",
				fileName: "file",
				fileSizeBytes: 10,
				format: "PDF",
				createdBy: "upload-user-1",
				createdAt: "2025-03-11T00:00:00.000Z"
			}]
		}
	}
}), $ = {
	id: "quote-123",
	isSignaturesEnabled: !0,
	counterSigners: [],
	pdfStatus: "GENERATED",
	attachmentAssets: [],
	readyToSignAt: "2024-05-28T10:55:57.866181Z",
	isExpired: !1,
	expiryDays: 60,
	contacts: [],
	archivedAt: "2024-05-28T10:55:57.866181Z",
	createdBy: "user-123",
	customerId: "customer-123",
	quoteNumber: "QUOTE-123",
	title: "Test Quote",
	currency: "USD",
	presentation: [],
	status: "ACCEPTED",
	dealType: "NEW_BUSINESS",
	expiresAt: "2024-07-30",
	publishedAt: "2024-05-28T10:55:57.866181Z",
	createdAt: "2024-05-28T10:55:57.866181Z",
	updatedAt: "2024-05-28T10:55:57.866181Z",
	merchantBranding: {
		email: "foo@bar.com",
		legalCompanyName: "Test Company",
		address: {
			line1: "123 Test St",
			town: "Test City",
			postcode: "12345",
			country: "US"
		}
	},
	phases: []
};
({ ...$ });
//#endregion
//#region src/clients/dashboard/v20240730/endpoints/quotes/postQuote/postQuote.api.ts
var Ca = n({
	route: () => "/quotes",
	method: "POST",
	invalidateQueries: [M],
	body: ({ body: e }) => JSON.stringify(e),
	mocking: {
		match: /\/api\/quotes$/,
		mock: {
			...$,
			status: "DRAFT"
		}
	}
}), wa = n({
	route: ({ id: e }) => `/quotes/${e}/publish`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		M,
		N,
		dr
	],
	mocking: {
		match: /\/api\/quotes\/(.+)\/publish$/,
		mock: {
			outcome: "PUBLISHED",
			approvalAutomationId: void 0
		}
	}
}), Ta = n({
	route: ({ id: e }) => `/quotes/${e}/accept`,
	method: "POST",
	invalidateQueries: [M, N],
	mocking: {
		match: /\/api\/quotes\/(.+)\/accept$/,
		mock: {
			...$,
			acceptedAt: "2024-05-28T10:55:57.866181Z"
		}
	}
}), Ea = n({
	route: ({ id: e }) => `/quotes/${e}/execute`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		M,
		N,
		E
	],
	mocking: {
		match: /\/api\/quotes\/(.+)\/execute$/,
		mock: {
			...$,
			status: "EXECUTED",
			preliminaryBillingStartDate: "2024-05-28",
			acceptedAt: "2024-05-28T10:55:57.866181Z",
			executedAt: "2024-05-28T10:55:57.866181Z"
		}
	}
}), Da = n({
	route: ({ id: e }) => `/quotes/${e}/ready-to-sign`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [M, N],
	mocking: {
		match: /\/api\/quotes\/(.+)\/ready-to-sign$/,
		mock: void 0
	}
}), Oa = n({
	route: ({ id: e }) => `/quotes/${e}/duplicate`,
	method: "POST",
	invalidateQueries: [M],
	mocking: {
		match: /\/api\/quotes\/(.+)\/duplicate$/,
		mock: {
			...$,
			status: "DRAFT"
		}
	}
}), ka = n({
	route: ({ id: e }) => `/quotes/${e}/archive`,
	method: "POST",
	invalidateQueries: [M],
	mocking: {
		match: /\/api\/quotes\/(.+)\/archive$/,
		mock: $
	}
}), Aa = n({
	route: ({ id: e }) => `/quotes/${e}/latest-draft`,
	method: "DELETE",
	invalidateQueries: [M, N],
	mocking: {
		match: /\/api\/quotes\/(.+)\/latest-draft$/,
		mock: {
			id: "quote-123",
			contacts: [],
			readyToSignAt: "2024-05-28T10:55:57.866181Z",
			isSignaturesEnabled: !0,
			counterSigners: [],
			pdfStatus: "GENERATED",
			attachmentAssets: [],
			isExpired: !1,
			expiryDays: 60,
			createdBy: "user-123",
			customerId: "customer-123",
			quoteNumber: "QUOTE-123",
			title: "Test Quote",
			currency: "USD",
			presentation: [],
			status: "PUBLISHED",
			dealType: "NEW_BUSINESS",
			expiresAt: "2024-07-30",
			publishedAt: "2024-05-28T10:55:57.866181Z",
			createdAt: "2024-05-28T10:55:57.866181Z",
			updatedAt: "2024-05-28T10:55:57.866181Z",
			merchantBranding: {
				legalCompanyName: "Test Company",
				email: "foo@bar.com",
				address: {
					line1: "123 Test St",
					town: "Test City",
					postcode: "12345",
					country: "US"
				}
			},
			phases: []
		}
	}
}), ja = n({
	route: ({ id: e }) => `/quotes/${e}/generate-pdf`,
	method: "POST",
	body: ({ quoteVariantId: e }) => JSON.stringify({ quoteVariantId: e }),
	invalidateQueries: [
		M,
		N,
		U,
		W
	],
	mocking: {
		match: /\/api\/quotes\/(.+)\/generate-pdf$/,
		mock: void 0
	}
}), Ma = n({
	route: () => "/quotes/archive",
	body: ({ quoteIds: e }) => JSON.stringify({ quoteIds: e }),
	method: "POST",
	invalidateQueries: [M, c],
	mocking: {
		match: /\/quotes\/archive$/,
		mock: {
			id: "d3f7c2a1-6b4e-4c8a-9f12-7a5e3b8c1d09",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "ARCHIVE_QUOTES",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), Na = n({
	route: () => "/quotes/download",
	body: ({ quoteIds: e }) => JSON.stringify({ quoteIds: e }),
	method: "POST",
	invalidateQueries: [c],
	mocking: {
		match: /\/quotes\/download$/,
		mock: {
			id: "f1a2b3c4-5d6e-4f70-8901-2a3b4c5d6e7f",
			sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
			type: "DOWNLOAD_QUOTES",
			status: "PROCESSING",
			createdAt: "2022-06-28T16:47:00Z",
			requestedIds: [],
			completedIds: [],
			failedIds: [],
			skippedIds: []
		}
	}
}), Pa = t({
	route: ({ bulkActionId: e }) => `/quotes/bulk-downloads/${e}`,
	config: { responseTransform: (e) => e.blob() },
	queryKey: [Gt],
	mocking: {
		match: /\/quotes\/bulk-downloads\/[^\/]+$/,
		mock: new Blob([""], { type: "application/zip" })
	}
}), Fa = t({
	route: ({ id: e }) => `/quotes/${e}/published`,
	queryKey: [N],
	mocking: {
		match: /\/api\/quotes\/([^/]+)\/published$/,
		mock: {
			...$,
			status: "PUBLISHED",
			publishedAt: "2024-05-28T10:55:57.866181Z"
		}
	}
}), Ia = n({
	route: ({ quoteId: e }) => `/quotes/${e}/notify-recipients`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [M, N],
	mocking: {
		match: /\/api\/quotes\/([^/]+)\/notify-recipients$/,
		status: 202,
		mock: void 0
	}
}), La = /* @__PURE__ */ e({}), Ra = {
	getQuote: qt,
	getPublishedQuote: Fa,
	getQuotes: xa,
	putQuote: Sa,
	postQuote: Ca,
	postQuoteAccept: Ta,
	postQuoteArchive: ka,
	postQuoteDuplicate: Oa,
	postQuoteExecute: Ea,
	deleteQuoteDraftVariant: Aa,
	postQuoteReadyToSign: Da,
	postQuoteRegeneratePdf: ja,
	postQuotePublish: wa,
	postQuoteNotifyRecipients: Ia,
	postArchiveMultipleQuotes: Ma,
	postDownloadMultipleQuotes: Na,
	getQuoteBulkDownloadZip: Pa
}, za = /* @__PURE__ */ e({}), Ba = /* @__PURE__ */ e({ putMerchant: () => Va }), Va = n({
	route: ({ id: e }) => `/merchants/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [wn],
	mocking: {
		match: /\/api\/merchants\/(.+)$/,
		mock: {
			id: "123",
			sequenceAccountId: "seq-123",
			invoiceNumberPrefix: "INV",
			creditNoteNumberPrefix: "CRE",
			lastInvoiceNumber: 1e3,
			lastCreditNoteNumber: 1,
			legalCompanyName: "Company",
			address: {
				line1: "123 Fake Street",
				town: "London",
				postcode: "SW1A 1AA",
				country: "GB"
			},
			email: "foo@bar.com",
			defaultDueDateDays: 45,
			bankAccountDetails: [
				{
					key: "EUR",
					value: {
						type: "IBAN",
						iban: "GB82WEST12345698765432"
					}
				},
				{
					key: "GBP",
					value: {
						type: "UK_BANK_ACCOUNT",
						ukBankAccount: {
							sortCode: "123456",
							accountNumber: "12345678"
						}
					}
				},
				{
					key: "USD",
					value: {
						type: "US_ACH",
						usAchDestination: {
							accountNumber: "12345678",
							accountName: "John Doe",
							bankName: "Bank of America",
							bankRoutingNumber: "123456789"
						}
					}
				},
				{
					key: "ZAR",
					value: {
						type: "US_WIRE",
						usWireDestination: {
							accountNumber: "12345678",
							accountName: "John Doe",
							bankName: "Bank of America",
							bankRoutingNumber: "123456789",
							swiftCode: "BOFAUS3N",
							bankAddress: {
								line1: "123 Fake Street",
								town: "London",
								postcode: "SW1A 1AA",
								country: "GB"
							}
						}
					}
				},
				{
					key: "CAD",
					value: {
						type: "CA_BANK_ACCOUNT",
						canadianBankAccount: {
							transitNumber: "123456789",
							institutionNumber: "123",
							accountNumber: "12345678"
						}
					}
				},
				{
					key: "JPY",
					value: {
						type: "CA_INTERNATIONAL",
						canadianInternationalDestination: {
							legalName: "Company",
							accountNumber: "12345678",
							transitNumber: "123456789",
							bankName: "Bank of America",
							bankAddress: {
								line1: "123 Fake Street",
								town: "London",
								postcode: "SW1A 1AA",
								country: "GB"
							},
							institutionNumber: "123",
							swiftCode: "BOFAUS3N",
							intermediaryBank: {
								bankName: "Bank of America",
								bankAddress: {
									line1: "123 Fake Street",
									town: "London",
									postcode: "SW1A 1AA",
									country: "GB"
								},
								swiftCode: "BOFAUS3N",
								routingNumber: "123456789"
							}
						}
					}
				},
				{
					key: "AUD",
					value: {
						type: "AUSTRALIAN",
						australianDestination: {
							legalName: "Company",
							accountNumber: "12345678",
							swiftCode: "BOFAUS3N",
							bsb: "123456"
						}
					}
				}
			],
			customerPortalEnabled: !0,
			includeBeneficiaryAddressInPaymentDetails: !0,
			ccMerchantOnInvoiceEmails: !0,
			showUsageInCustomerPortal: !0,
			customerPortalAuthRequirement: "REQUIRED"
		}
	}
}), Ha = { putMerchant: Va }, Ua = t({
	route: ({ signature: e }) => `/revenue/journal-reports/download?signature=${encodeURIComponent(e)}`,
	queryKey: ["journalReportSignedDownload"],
	mocking: {
		match: /\/api\/revenue\/journal-reports\/download\?signature=/,
		mock: { url: "https://cdn.example.com/export.csv" }
	}
}), Wa = "revenueRecognitionSettings", Ga = {
	getJournalReportSignedDownload: Ua,
	getRevenueRecognitionSettings: t({
		route: () => "/revenue/settings",
		queryKey: [Wa],
		mocking: {
			match: /\/api\/revenue\/settings$/,
			mock: {
				id: "37fd90d2-3f9a-41c7-9bea-3d5f82bb11fa",
				sequenceAccountId: "8eafb503-5605-4725-99e1-a1f0fc5bbb17",
				recognizeRevenueOnAccountingDate: !1,
				allocationPartialProrationStrategy: "PRORATE_DAILY",
				integrationsJournalPostMode: "DRAFT"
			}
		}
	}),
	putRevenueRecognitionSettings: n({
		route: () => "/revenue/settings",
		method: "PUT",
		body: (e) => JSON.stringify(e.body),
		invalidateQueries: [Wa],
		mocking: {
			match: /\/api\/revenue\/settings$/,
			mock: {
				id: "37fd90d2-3f9a-41c7-9bea-3d5f82bb11fa",
				sequenceAccountId: "8eafb503-5605-4725-99e1-a1f0fc5bbb17",
				recognizeRevenueOnAccountingDate: !1,
				allocationPartialProrationStrategy: "PRORATE_DAILY",
				integrationsJournalPostMode: "DRAFT"
			}
		}
	})
}, Ka = /* @__PURE__ */ e({
	DeleteHubspotDealQuoteLink: () => ar,
	DeleteLinkedEntity: () => Zn,
	DeleteNotificationPolicy: () => Yi,
	DeleteNotificationPolicyRecipients: () => na,
	DeleteNotificationPolicyType: () => oa,
	DeleteOAuthClient: () => hn,
	DeleteUser: () => sn,
	GetAllIntegrationCustomers: () => qn,
	GetAllNotificationPolicies: () => qi,
	GetCreditNotePdf: () => ha,
	GetCreditNotesCsvDownload: () => la,
	GetCreditNotesSettings: () => da,
	GetHubspotCompanyDeals: () => tr,
	GetInsightsCustomerTotals: () => ei,
	GetInsightsInvoicedRevenue: () => ii,
	GetInsightsOutstandingInvoices: () => ni,
	GetInsightsUsageData: () => oi,
	GetInsightsUsageEvents: () => Qr,
	GetIntegration: () => Yn,
	GetIntegrationCustomersService: () => $n,
	GetIntegrationProductsService: () => sr,
	GetMerchantForSequenceAccount: () => Tn,
	GetNotificationPolicy: () => $i,
	GetOAuthClients: () => _n,
	GetPrice: () => Vi,
	GetPriceMetadata: () => Ui,
	GetSeatBalances: () => Ci,
	GetSeatEvent: () => xi,
	GetSeatEvents: () => Ti,
	GetSeatMetric: () => Fi,
	GetSeatMetrics: () => Di,
	GetSeatTotals: () => Ni,
	GetSequenceAccount: () => Ln,
	GetSequenceAccountId: () => jn,
	GetSequenceAccountSettings: () => Nn,
	GetTaxRates: () => li,
	GetUser: () => ln,
	GetUsers: () => dn,
	Merchants: () => za,
	PostArchiveTaxRate: () => _i,
	PostCreateCustomerFromExternalService: () => Mr,
	PostCreateCustomerFromExternalServiceProgress: () => Pr,
	PostCreateGoogleSheetsInsightsExport: () => Ar,
	PostIssueAndApplyCreditNote: () => _a,
	PostNewTaxRateVersion: () => di,
	PostNotificationPolicy: () => Zi,
	PostNotificationPolicyRecipients: () => ta,
	PostNotificationPolicyType: () => ia,
	PostOAuthClient: () => yn,
	PostPushCreditNoteApplicationToExternalService: () => vr,
	PostPushCreditNoteToExternalService: () => gr,
	PostPushCustomerToExternalService: () => wr,
	PostPushInvoiceToExternalService: () => Sr,
	PostPushPaymentToExternalService: () => br,
	PostPushProductToExternalService: () => Er,
	PostSeatEvent: () => ki,
	PostSeatMetric: () => ji,
	PostSequenceAccountInvite: () => zn,
	PostSession: () => xn,
	PostSyncHubspotCustomers: () => Rr,
	PostSyncInvoiceWithExternalService: () => Ir,
	PostTaxRate: () => pi,
	PostValidateExternalEntity: () => Or,
	Prices: () => Gi,
	PutCreditNotesSettings: () => pa,
	PutHubspotDealQuoteLink: () => rr,
	PutHubspotSettings: () => Br,
	PutMerchant: () => Ba,
	PutQuickbooksSettings: () => Hr,
	PutSeatMetric: () => Li,
	PutSequenceAccount: () => Vn,
	PutSequenceAccountSettings: () => Fn,
	PutTaxRate: () => hi,
	PutXeroSettings: () => Wr,
	Quotes: () => La,
	Seats: () => zi,
	SequenceAccount: () => Un,
	Users: () => pn,
	assetsEndpoints: () => L,
	authEndpoints: () => Cn,
	creditGrantEndpoints: () => wt,
	creditNotesEndpoints: () => ya,
	customerEndpoints: () => rn,
	endpoints20240730: () => qa,
	insightsEndpoints: () => ci,
	integrationEndpoints: () => Kr,
	invoiceEndpoints: () => Ct,
	merchantEndpoints: () => Ha,
	notificationsEndpoints: () => ca,
	priceEndpoints: () => Ki,
	quickbooksEndpoints: () => on,
	quoteEndpoints: () => Ra,
	quoteTemplatesEndpoints: () => Qt,
	revenueRecognitionEndpoints: () => Ga,
	savedViewsEndpoints: () => Vt,
	schedulesEndpoints: () => Bt,
	seatsEndpoints: () => Bi,
	sequenceAccountEndpoints: () => Wn,
	taxRatesEndpoints: () => yi,
	taxRegistrationsEndpoints: () => ba,
	usageEventsEndpoints: () => tn,
	usageMetricEndpoints: () => nn,
	userEndpoints: () => mn
}), qa = {
	getAccountPaymentSettings: oe,
	getBillingProducts: he,
	getBillingSettings: ve,
	getBulkActions: re,
	getTaxCategories: se,
	getTaxCategory: ce,
	postNewTaxCategoryVersion: ge,
	postProductArchive: pe,
	postCancelBulkAction: ae,
	postReviewBulkAction: ie,
	postTaxCategory: le,
	putAccountPaymentSettings: de,
	putBillingSettings: ye,
	putTaxCategory: ue,
	...wt,
	...Bt,
	...Vt,
	...Qt,
	...Ct,
	...tn,
	...nn,
	...rn,
	...L,
	...mn,
	...Cn,
	...Wn,
	...L,
	...on,
	...Kr,
	...ci,
	...Bi,
	...yi,
	...Ki,
	...ca,
	...ya,
	...ba,
	...Ra,
	...Ha,
	...Ga
}, Ja = ee({
	endpoints: qa,
	version: "2024-07-30"
});
//#endregion
export { m as A, Ve as C, g as D, _ as E, c as M, d as O, y as S, ze as T, ft as _, dr as a, He as b, V as c, C as d, St as f, dt as g, lt as h, lr as i, me as j, p as k, T as l, ut as m, Ka as n, ur as o, ct as p, W as r, U as s, Ja as t, w as u, x as v, Be as w, Ue as x, st as y };

//# sourceMappingURL=v20240730-d4WzapES.js.map